'use client';
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Flex,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorModeValue,
   useDisclosure,
   Drawer,
   DrawerOverlay,
   DrawerContent,
   DrawerCloseButton,
   DrawerHeader,
   DrawerBody,
   useOutsideClick,
   VStack,
   Spinner,
   useColorMode,
} from '@chakra-ui/react';
import Select from 'react-select';
import 'jspdf-autotable';
import Card from 'components/card/Card';
import { GridItem, Input } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import { Button, Image, Thead, Th, Grid, IconButton } from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { deletePurchaseInvoice, getSinglePurchaseWithPrevAndNext } from '../../../../redux/actions/purchaseInvoice';
import { deleteRecord } from 'utils/util';
import SalesPurchaseFilter from '../components/SalesPurchaseFilter';
import { useDispatch, useSelector } from 'react-redux';
import cancel from '../../../../assets/img/nfts/cancel.svg';
import { deleteReportFormat, getReportFormat, getReportPurchaseDetail } from '../../../../redux/actions/reports';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import { ChevronDownIcon, ChevronUpIcon, SearchIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { REPORT_TYPE } from 'constants';
import { renderDynamicDropdown } from '../../../../components/ui/DynamicDropdown';
import { jsPDF } from 'jspdf';
import * as XLSX from 'xlsx-js-style';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { useGlobal, useUser, useBusinessType } from '../../../../contexts';
import { IoFilterOutline } from 'react-icons/io5';
import ColumnShowHide from '../components/Columnshowhide';
import { MdDelete, MdOutlineRefresh } from 'react-icons/md';
import { LucideEdit } from 'lucide-react';
import { FiPlusCircle } from 'react-icons/fi';
import {
   deletePurchaseReturnInvoice,
   getSinglePurchaseReturnWithPrevAndNext,
} from '../../../../redux/actions/purchaseReturnInvoice';
import Loader from 'views/admin/default/Loader';
import DeletePasswordModal from 'views/admin/sales/Pages/SalesInvoiceMaster/DeletePasswordModal';
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

const PurchaseReturnDetail = () => {
   const dispatch = useDispatch();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const fromDateInputRef = useRef(null);
   const columnHelper = createColumnHelper();
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
   const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
   const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
   const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
   const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
   const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
   const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
   const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
   const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');
   const { companyList, company } = useGlobal();
   const { userGlobalSettingsData } = useGlobal();
   const [fromDate, setFromDate] = useState(null);
   const [companyFilter, setCompanyFilter] = useState([]);
   const [reportType, setReportType] = useState('date');
   const [isFilterLoading, setIsFilterLoading] = useState(false);
   const isFirstRenderFilter = useRef(true);
   const [formatType, setFormatType] = useState('with_item_detail');
   const [expandedItems, setExpandedItems] = useState({});
   const [sorting, setSorting] = useState([]);
   const [columnVisibility, setColumnVisibility] = useState({ brokername: false });
   const dbName = company?.dbName;
   const [searchQuery, setSearchQuery] = useState('');
   const [isSearchLoading, setIsSearchLoading] = useState(false);
   const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);

      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0], // last 7th day
         toDate: today.toISOString().split('T')[0], // today
      };
   });
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const reportformat = useSelector((state) => state.reports?.reportFormat || []);
   const [showHideData, setShowHideData] = useState({});
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [dataId, setDataId] = useState(null);
   const [isShowHideColumn, setIsShowHideColumn] = useState(false);
   const allowedDefNames = ['PurchaseReturnDetailDate', 'PurchaseReturnDetailParty', 'PurchaseReturnDetailBroker'];
   const dynamicOptions = reportformat
      .filter((item) => item.defName && allowedDefNames.includes(item.defName))
      .map((item) => ({
         id: item.id,
         value: item.defName && item.title,
         label: item.title,
         isDynamic: true,
         formatData: item,
      }));
   const dynamicValues = dynamicOptions.map((option) => option.value);
   const dynamicOptionValues = dynamicOptions.find((option) => option.value === reportType);
   const dynamicEditOption = dynamicOptionValues?.formatData.defName;
   const handleReportTypeChange = (selectedOption) => {
      setReportType(selectedOption.value);
      setExpandedItems({});
      dispatch(getReportFormat());
   };
   const { user } = useUser();
   const admin = user?.isAdmin;
   const rights = user?.userRights?.find((ur) => ur?.companyId === user?.loginhistory?.companyId);
   const { businessTypes } = useBusinessType();
   const isTextile = businessTypes?.businessType === 'TEXTILE';
   const daybookData = useSelector((state) => state.daybook?.list || []);
   const companyId = Number(localStorage.getItem('companyId'));
   const userRights = user?.user?.userRights || user?.userRights;
   const purchaseInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchaseinvoice
      : null;
   const purchaseReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchasereturn
      : null;

   const isStaticReportType = ['date', 'party', 'broker'].includes(reportType);
   const getColumnsReportsSalesDetail = useCallback((formatType, reportType) => {
      const isPartyReport = reportType === 'party' || dynamicEditOption === 'PurchaseReturnDetailParty';
      const isDateReport = dynamicEditOption === 'PurchaseReturnDetailDate';

      // Use the passed selectedFormat or fallback to finding from reportformat array
      // const formatToUse = dynamicOptionValues || dynamicOptionValues.formatData;

      const viewJson = dynamicOptionValues?.formatData?.viewJson || [];

      const convertBackendColor = (backendColor) => {
         if (!backendColor) return null;
         if (backendColor.startsWith('#')) return backendColor;
         if (backendColor.startsWith('0xff')) return '#' + backendColor.substring(4);
         if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) return '#' + backendColor;
         return backendColor;
      };

      const getColumnInfo = (defName) => {
         // First try to find by defName, then by title
         const viewItem = viewJson.find(
            (item) =>
               item?.defName?.toLowerCase() === defName.toLowerCase() ||
               item?.title?.toLowerCase() === defName.toLowerCase(),
         );

         if (!viewItem || isStaticReportType) {
            // Return default values if no customization found or for static report types
            return {
               title: defName,
               isShow: true,
               color: textColor,
               isBold: false,
               isItalic: false,
               orderNo: 0,
               flex: 1,
            };
         }

         return {
            title: viewItem.title || defName,
            isShow: viewItem.isShow === 'true' || viewItem.isShow === true,
            color: viewItem.color ? convertBackendColor(viewItem.color) : textColor,
            isBold: viewItem.isBold === 'true' || viewItem.isBold === true,
            isItalic: viewItem.isItalic === 'true' || viewItem.isItalic === true,
            orderNo: viewItem.orderNo ? parseInt(viewItem.orderNo) : 0,
            flex: viewItem.flex ? parseInt(viewItem.flex) : 1,
         };
      };

      const baseColumns = [
         {
            id: 'transactionAt',
            header: getColumnInfo('date').title,
            accessor: 'transactionAt',
            isShow: getColumnInfo('date').isShow,
            color: getColumnInfo('date').color,
            isBold: getColumnInfo('date').isBold,
            isItalic: getColumnInfo('date').isItalic,
            orderNo: getColumnInfo('date').orderNo,
            flex: getColumnInfo('date').flex,
            cell: (info) => {
               const value = info.getValue();
               return value ? moment(value).format('DD-MM-YYYY') : value;
            },
         },
         {
            id: 'docno',
            header: getColumnInfo('doc').title,
            accessor: 'docno',
            isShow: getColumnInfo('doc').isShow,
            color: getColumnInfo('doc').color,
            isBold: getColumnInfo('doc').isBold,
            isItalic: getColumnInfo('doc').isItalic,
            orderNo: getColumnInfo('doc').orderNo,
            flex: getColumnInfo('doc').flex,
         },
         ...(!isPartyReport
            ? [
               {
                  id: 'accountname',
                  header: getColumnInfo('party').title,
                  accessor: 'accountname',
                  isShow: getColumnInfo('party').isShow,
                  color: getColumnInfo('party').color,
                  isBold: getColumnInfo('party').isBold,
                  isItalic: getColumnInfo('party').isItalic,
                  orderNo: getColumnInfo('party').orderNo,
                  flex: getColumnInfo('party').flex,
               },
            ]
            : []),
         ...(reportType === 'date'
            ? [
               {
                  id: 'mobile',
                  header: getColumnInfo('mobile').title,
                  accessor: 'mobile',
                  isShow: getColumnInfo('mobile').isShow,
                  color: getColumnInfo('mobile').color,
                  isBold: getColumnInfo('mobile').isBold,
                  isItalic: getColumnInfo('mobile').isItalic,
                  orderNo: getColumnInfo('mobile').orderNo,
                  flex: getColumnInfo('mobile').flex,
               },
            ]
            : []),
         {
            id: 'daybookname',
            header: getColumnInfo('daybook').title,
            accessor: 'daybookname',
            isShow: getColumnInfo('daybook').isShow,
            color: getColumnInfo('daybook').color,
            isBold: getColumnInfo('daybook').isBold,
            isItalic: getColumnInfo('daybook').isItalic,
            orderNo: getColumnInfo('daybook').orderNo,
            flex: getColumnInfo('daybook').flex,
         },
         {
            id: 'salesmanname',
            header: getColumnInfo('salesman').title,
            accessor: 'salesmanname',
            isShow: getColumnInfo('salesman').isShow,
            color: getColumnInfo('salesman').color,
            isBold: getColumnInfo('salesman').isBold,
            isItalic: getColumnInfo('salesman').isItalic,
            orderNo: getColumnInfo('salesman').orderNo,
            flex: getColumnInfo('salesman').flex,
         },
         {
            id: 'notes',
            header: getColumnInfo('notes').title,
            accessor: 'notes',
            isShow: getColumnInfo('notes').isShow,
            color: getColumnInfo('notes').color,
            isBold: getColumnInfo('notes').isBold,
            isItalic: getColumnInfo('notes').isItalic,
            orderNo: getColumnInfo('notes').orderNo,
            flex: getColumnInfo('notes').flex,
         },
         {
            id: 'totalQty1',
            header: getColumnInfo('qty').title,
            accessor: 'totalQty1',
            isNumeric: true,
            isShow: getColumnInfo('qty').isShow,
            color: getColumnInfo('qty').color,
            isBold: getColumnInfo('qty').isBold,
            isItalic: getColumnInfo('qty').isItalic,
            orderNo: getColumnInfo('qty').orderNo,
            flex: getColumnInfo('qty').flex,
         },
         {
            id: 'netAmount',
            header: getColumnInfo('netAmt').title,
            accessor: 'netAmount',
            isNumeric: true,
            isShow: getColumnInfo('netAmt').isShow,
            color: getColumnInfo('netAmt').color,
            isBold: getColumnInfo('netAmt').isBold,
            isItalic: getColumnInfo('netAmt').isItalic,
            orderNo: getColumnInfo('netAmt').orderNo,
            flex: getColumnInfo('netAmt').flex,
            cell: (info) => {
               const value = info.getValue();
               return `₹${Number(value || 0).toLocaleString()}`;
            },
         },
         {
            id: 'basicAmount',
            header: getColumnInfo('billAmt').title,
            accessor: 'basicAmount',
            isNumeric: true,
            isShow: getColumnInfo('billAmt').isShow,
            color: getColumnInfo('billAmt').color,
            isBold: getColumnInfo('billAmt').isBold,
            isItalic: getColumnInfo('billAmt').isItalic,
            orderNo: getColumnInfo('billAmt').orderNo,
            flex: getColumnInfo('billAmt').flex,
            cell: (info) => {
               const value = info.getValue();
               return `₹${Number(value || 0).toLocaleString()}`;
            },
         },
      ];

      if (formatType === 'with_item_detail') {
         let itemDetailColumns = [];

         if (reportType === 'date') {
            itemDetailColumns = [
               {
                  id: 'itemName',
                  header: getColumnInfo('itemName').title,
                  accessor: 'itemName',
                  isShow: getColumnInfo('itemName').isShow,
                  color: getColumnInfo('itemName').color,
                  isBold: getColumnInfo('itemName').isBold,
                  isItalic: getColumnInfo('itemName').isItalic,
                  orderNo: getColumnInfo('itemName').orderNo,
                  flex: getColumnInfo('itemName').flex,
                  cell: (info) => {
                     const value = info.getValue();
                     return (
                        <div
                           className="text-center px-2 py-1"
                           style={{
                              textAlign: 'center',
                              wordWrap: 'break-word',
                              whiteSpace: 'normal',
                              maxWidth: '200px',
                              minWidth: '150px',
                           }}
                           title={value}>
                           {value}
                        </div>
                     );
                  },
               },
               ...(isTextile ? [] : [{
                  id: 'serialNo',
                  header: getColumnInfo('serialNo').title,
                  accessorKey: 'serialNo',
                  isShow: getColumnInfo('serialNo').isShow,
                  color: getColumnInfo('serialNo').color,
                  isBold: getColumnInfo('serialNo').isBold,
                  isItalic: getColumnInfo('serialNo').isItalic,
                  orderNo: getColumnInfo('serialNo').orderNo,
                  flex: getColumnInfo('serialNo').flex,
               }]),
               {
                  id: 'itemRate',
                  header: getColumnInfo('rate').title,
                  accessor: 'itemRate',
                  isNumeric: true,
                  isShow: getColumnInfo('rate').isShow,
                  color: getColumnInfo('rate').color,
                  isBold: getColumnInfo('rate').isBold,
                  isItalic: getColumnInfo('rate').isItalic,
                  orderNo: getColumnInfo('rate').orderNo,
                  flex: getColumnInfo('rate').flex,
               },
            ];
         } else {
            itemDetailColumns = [
               {
                  id: 'itemName',
                  header: getColumnInfo('itemName').title,
                  accessor: 'itemName',
                  isShow: getColumnInfo('itemName').isShow,
                  color: getColumnInfo('itemName').color,
                  isBold: getColumnInfo('itemName').isBold,
                  isItalic: getColumnInfo('itemName').isItalic,
                  orderNo: getColumnInfo('itemName').orderNo,
                  flex: getColumnInfo('itemName').flex,
                  cell: (info) => {
                     const value = info.getValue();
                     return (
                        <div
                           className="text-center px-2 py-1"
                           style={{
                              textAlign: 'center',
                              wordWrap: 'break-word',
                              whiteSpace: 'normal',
                              maxWidth: '200px',
                              minWidth: '150px',
                           }}
                           title={value}>
                           {value}
                        </div>
                     );
                  },
               },
               ...(isTextile ? [] : [{
                  id: 'serialNo',
                  header: getColumnInfo('serialNo').title,
                  accessorKey: 'serialNo',
                  isShow: getColumnInfo('serialNo').isShow,
                  color: getColumnInfo('serialNo').color,
                  isBold: getColumnInfo('serialNo').isBold,
                  isItalic: getColumnInfo('serialNo').isItalic,
                  orderNo: getColumnInfo('serialNo').orderNo,
                  flex: getColumnInfo('serialNo').flex,
               }]),
               {
                  id: 'itemRate',
                  header: getColumnInfo('rate').title,
                  accessor: 'itemRate',
                  isNumeric: true,
                  isShow: getColumnInfo('rate').isShow,
                  color: getColumnInfo('rate').color,
                  isBold: getColumnInfo('rate').isBold,
                  isItalic: getColumnInfo('rate').isItalic,
                  orderNo: getColumnInfo('rate').orderNo,
                  flex: getColumnInfo('rate').flex,
               },
               ...(!isDateReport
                  ? [
                     {
                        id: 'hsnSac',
                        header: getColumnInfo('HSN/SAC').title || 'HSN/SAC',
                        accessor: 'hsnSac',
                        isShow: getColumnInfo('HSN/SAC').isShow,
                        color: getColumnInfo('HSN/SAC').color,
                        isBold: getColumnInfo('HSN/SAC').isBold,
                        isItalic: getColumnInfo('HSN/SAC').isItalic,
                        orderNo: getColumnInfo('HSN/SAC').orderNo,
                        flex: getColumnInfo('HSN/SAC').flex,
                     },
                     {
                        id: 'dueDays',
                        header: getColumnInfo('Due Days').title || 'Due Days',
                        accessor: 'dueDays',
                        isShow: getColumnInfo('Due Days').isShow,
                        color: getColumnInfo('Due Days').color,
                        isBold: getColumnInfo('Due Days').isBold,
                        isItalic: getColumnInfo('Due Days').isItalic,
                        orderNo: getColumnInfo('Due Days').orderNo,
                        flex: getColumnInfo('Due Days').flex,
                     },
                  ]
                  : []),
            ];
         }

         // Insert item details after account/mobile columns
         const insertIndex =
            reportType === 'date'
               ? baseColumns.findIndex((col) => col.id === 'mobile') + 1
               : baseColumns.findIndex((col) => col.id === 'docno') + 1;

         baseColumns.splice(insertIndex, 0, ...itemDetailColumns);
      }

      // Filter out columns where isShow is false
      return baseColumns
         .filter((col) => col.isShow !== false)
         .sort((a, b) => {
            const orderA = a.orderNo || 0;
            const orderB = b.orderNo || 0;
            return orderA - orderB;
         });
   });
   const companyIds = useMemo(
      () =>
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [],
      [companyFilter],
   );
   const staticReportTypeOptions = [
      { value: 'date', label: 'Date' },
      { value: 'party', label: 'Party' },
      { value: 'broker', label: 'Broker' },
   ];

   const reportTypeOptions = [
      ...staticReportTypeOptions,
      ...(dynamicOptions.length > 0
         ? [
            {
               label: 'Custom Formats',
               options: dynamicOptions,
            },
         ]
         : []),
   ];
   const staticOption = staticReportTypeOptions.find((option) => option.value === reportType);

   const formatTypeOptions = [
      { value: 'with_item_detail', label: 'With Item Detail' },
      { value: 'without_item_detail', label: 'Without Item Detail' },
   ];

   useEffect(() => {
      dispatch(getReportFormat());
   }, [dispatch]);

   const formatOptionLabel = ({ label, isDynamic, id }, { context }) => (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
         <span>{label}</span>
         {isDynamic && context === 'menu' && (
            <button
               onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteFormat(id);
               }}
               style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#ff4d4f',
                  padding: '0 5px',
               }}
               title="Delete this format">
               <MdDelete />
            </button>
         )}
      </div>
   );

   const handleDeleteFormat = async (id) => {
      try {
         // Call the action creator
         await dispatch(deleteReportFormat(id));

         // Reset edit state if this was the currently edited format
         if (editData?.id === id) {
            setIsEditShowHide(false);
            setEditData({});
         }
         dispatch(getReportFormat());
      } catch (error) {
         // Errors are already handled in the action creator
         console.error('Delete error:', error);
      }
   };

   const handleCompanyChange = (selectedOptions) => {
      setCompanyFilter(selectedOptions ? selectedOptions : []);
   };

   const dynamicColumns = useMemo(() => {
      // Assuming reportformat[0] contains your format data
      const format = reportformat.find((f) => f.id === reportType) || reportformat[0];
      return getColumnsReportsSalesDetail(formatType, reportType, format);
   }, [formatType, reportType, reportformat]);

   const handleNextPage = () => {
      console.log('Next');
   };
   const handlePrevPage = () => {
      console.log('Prev');
   };

   useEffect(() => {
      const initialColumnVisibility = {};
      dynamicColumns.forEach((column) => {
         initialColumnVisibility[column.id] = column.id === 'brokername' ? false : true;
      });
      setColumnVisibility(initialColumnVisibility);
   }, [dynamicColumns]);

   const columnsData = useMemo(() => {
      return dynamicColumns.map((col, index) => ({
         key: col?.id,
         label: col?.header,
         title: col?.header,
         width: col?.width,
         index: index + 1,
         status: true,
      }));
   }, [dynamicColumns]);

   useEffect(() => {
      if (Object.keys(showHideData).length === 0) {
         setShowHideData(columnsData);
      }
   }, [showHideData, columnsData]);

   const columns = useMemo(() => {
      return dynamicColumns.map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color={isDark ? '#FFF' : '#000'}>
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );
   }, [columnHelper, dynamicColumns, textColor]);
   const getVisibleColumnsCount = () => {
      return table.getAllColumns().filter((column) => column.getIsVisible()).length;
   };
   const [isEditShowHide, setIsEditShowHide] = useState(false); // State to store selected value
   const [editData, setEditData] = useState({}); // State to store selected value
   const salesReport = useSelector((state) => state.reports?.purchaseDetail || []);

   const viewData = useSelector((state) => state?.purchaseReturnInvoice?.purchaseReturnData);
   const { viewDetail, paginate } = useMemo(() => {
      const data = viewData?.data[0];

      const pagination = viewData?.pagination;

      return { viewDetail: data, paginate: pagination };
   }, [viewData?.data, viewData?.pagination]);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);

   const { isOpen, onOpen, onClose } = useDisclosure();
   const searchTimeoutRef = useRef(null);
   const [isLoading, setIsLoading] = useState(false);

   const table = useReactTable({
      data: salesReport,
      columns,
      state: {
         sorting,
         columnVisibility,
      },
      onSortingChange: setSorting,
      onColumnVisibilityChange: setColumnVisibility,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
      initialState: {
         columnVisibility: {
            brokername: false,
         },
      },
   });

   const calculateColumnWidths = () => {
      const visibleColumns = dynamicColumns.filter((col) => columnVisibility[col.id]);
      const totalFlex = visibleColumns.reduce((sum, col) => sum + (col.flex || 1), 0);
      const availableWidth = 100; // This represents 100% of the table width

      return visibleColumns.map((col) => {
         const flexValue = col.flex || 1;
         return `${(flexValue / totalFlex) * availableWidth}%`;
      });
   };

   const columnWidths = calculateColumnWidths();

   const toggleExpand = (id) => {
      setExpandedItems((prev) => ({
         ...prev,
         [id]: !prev[id],
      }));
   };

   useEffect(() => {
      if (!dateRange.fromDate) {
         const today = new Date();
         today.setFullYear(today.getFullYear() - 1);
         const formattedDate = today.toISOString().split('T')[0];
         setFromDate(formattedDate);
      }
   }, [dateRange.fromDate]);

   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   useEffect(() => {
      const storedCompanyId = localStorage.getItem('companyId');
      if (storedCompanyId && companyList.length > 0) {
         const companyId = parseInt(storedCompanyId);
         const matchingCompany = companyList.find((comp) => comp.id === companyId);
         if (matchingCompany) {
            setCompanyFilter([matchingCompany.id]);
         }
      }
   }, [companyList]);

   const handleDateRangeChange = (dates) => {
      if (!dates || dates.length !== 2) return;

      const [from, to] = dates.map((date) =>
         moment.isMoment(date)
            ? date.format('YYYY-MM-DD') // keep it local
            : moment(date).format('YYYY-MM-DD'),
      );

      setDateRange({ fromDate: from, toDate: to });
   };

   const fetchData = useCallback(async () => {
      if (isSearchLoading) return; // Prevent multiple simultaneous requests

      setIsLoading(true);
      setIsSearchLoading(true);

      try {
         const companyIds =
            companyFilter.length > 0
               ? companyFilter
               : localStorage.getItem('companyId')
                  ? [parseInt(localStorage.getItem('companyId'))]
                  : [];

         if (!dateRange || !companyIds.length) {
            return;
         }

         await dispatch(
            getReportPurchaseDetail({
               companyIds: companyIds.join(','),
               type: reportType,
               isReturn: 1,
               fromDate: dateRange.fromDate,
               toDate: dateRange.toDate,
               search: debouncedSearchQuery,
            }),
         );
      } catch (error) {
         console.error('Error fetching purchase details:', error);
      } finally {
         setIsLoading(false);
         setIsSearchLoading(false);
      }
   }, [dispatch, companyFilter, reportType, debouncedSearchQuery, dateRange]);

   useEffect(() => {
      fetchData();
   }, [fetchData]);

   useEffect(() => {
      if (isFirstRenderFilter.current) {
         isFirstRenderFilter.current = false;
         return;
      }
      setIsFilterLoading(false);
   }, [salesReport]);

   const handleRefresh = useCallback(() => {
      fetchData();
   }, [fetchData]);

   const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchQuery(value); // Update UI immediately

      // Clear any existing timeout
      if (searchTimeoutRef.current) {
         clearTimeout(searchTimeoutRef.current);
      }

      // Set a new timeout
      searchTimeoutRef.current = setTimeout(() => {
         setDebouncedSearchQuery(value);
      }, 500); // 500ms delay
   };

   // In useEffect cleanup
   useEffect(() => {
      return () => {
         if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
         }
      };
   }, []);

   useEffect(() => {
      const handler = setTimeout(() => {
         setDebouncedSearchQuery(searchQuery);
      }, 500);

      return () => {
         clearTimeout(handler);
      };
   }, [searchQuery]);

   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   useEffect(() => {
      return () => {
         if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
         }
      };
   }, []);

   // Add this useEffect to set initial expanded state when salesReport changes
   useEffect(() => {
      if (salesReport && salesReport.length > 0) {
         const initialExpandedState = {};

         if (reportType === REPORT_TYPE.party) {
            // Set company and account level expansions
            salesReport.forEach((companyData) => {
               initialExpandedState[`company-${companyData.companyId}`] = true;

               if (companyData.data && Array.isArray(companyData.data)) {
                  companyData.data.forEach((accountData) => {
                     initialExpandedState[`account-${accountData.accountId}`] = true;

                     // AUTO-EXPAND ITEMS: Add this section
                     if (accountData.data && Array.isArray(accountData.data)) {
                        accountData.data.forEach((transaction) => {
                           const hasMultipleItems =
                              transaction.purchaseLineItems &&
                              Array.isArray(transaction.purchaseLineItems) &&
                              transaction.purchaseLineItems.length > 1;

                           if (hasMultipleItems) {
                              initialExpandedState[`items-${transaction.id}`] = true;
                           }
                        });
                     }
                  });
               }
            });
         } else {
            // For date report type, auto-expand items too
            salesReport.forEach((dateItem) => {
               dateItem.data?.forEach((item) => {
                  if (item.data && Array.isArray(item.data)) {
                     item.data.forEach((transaction) => {
                        const hasMultipleItems =
                           transaction.purchaseLineItems &&
                           Array.isArray(transaction.purchaseLineItems) &&
                           transaction.purchaseLineItems.length > 1;

                        if (hasMultipleItems) {
                           initialExpandedState[`items-${transaction.id}`] = true;
                        }
                     });
                  }
               });
            });
         }

         setExpandedItems(initialExpandedState);
      }
   }, [salesReport, reportType]);

   const lastcompanyOptions = useMemo(() => {
      const currentUserCode = user?.loginhistory?.code;
      const currentCompanyId = user?.loginhistory?.companyId;

      // SHARED COMPANY MODE: When code is present
      if (currentUserCode) {
         // Find the company with matching ID AND matching dbName
         const sharedCompany = companyList.find(
            company => company.id === currentCompanyId && company.dbName === currentUserCode
         );

         if (sharedCompany) {
            return [{
               value: sharedCompany.id,
               label: sharedCompany.name,
               id: sharedCompany.id,
               name: sharedCompany.name,
            }];
         }

         // Fallback: try to find by dbName only
         const companiesWithDbName = companyList.filter(company => company.dbName === currentUserCode);
         if (companiesWithDbName.length > 0) {
            return companiesWithDbName.map(company => ({
               value: company.id,
               label: company.name,
               id: company.id,
               name: company.name,
            }));
         }

         return [];
      }

      // NORMAL MODE: When no code, show companies without dbName
      return companyList
         .filter(company => !company.dbName)
         .map(company => ({
            value: company.id,
            label: company.name,
            id: company.id,
            name: company.name,
         }));
   }, [companyList, user?.loginhistory?.code, user?.loginhistory?.companyId]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const isTargetInput =
            e.target.tagName === 'INPUT' ||
            e.target.tagName === 'TEXTAREA' ||
            e.target.tagName === 'SELECT' ||
            e.target.isContentEditable;

         if (e.key.toLowerCase() === 't' && !isTargetInput) {
            if (fromDateInputRef.current) {
               fromDateInputRef.current.focus();
            }
         }
      };

      document.addEventListener('keydown', handleKeyDown);

      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, []);
   const isAuthenticated = useSelector((state) => state.auth.login);
   const navigate = useNavigate();
   useEffect(() => {
      if (!isAuthenticated) {
         navigate('/auth/sign-in');
      }
   }, [isAuthenticated, navigate]);
   useEffect(() => {
      if (!isAuthenticated) return;

      // Main keyboard event handler
      const handleKeyDown = (event) => {
         if (!isAuthenticated) return;

         // Shift key shortcuts (work on all platforms)
         if (event.shiftKey && !event.ctrlKey && !event.metaKey) {
            switch (event.key.toLowerCase()) {
               case 's':
                  navigate('/admin/report/SalesDetail');
                  event.preventDefault();
                  break;
               case 'p':
                  navigate('/admin/report/PurchaseReturnDetail');
                  event.preventDefault();
                  break;
               default:
                  break;
            }
         }
      };

      // Add event listener
      document.addEventListener('keydown', handleKeyDown);

      // Cleanup function
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, [navigate, isAuthenticated]);

   // Add this function to calculate grand totals across all companies
   const calculateGrandTotals = useCallback(() => {
      if (!salesReport || salesReport.length === 0) return { totalQty: 0, totalAmt: 0 };

      let grandTotalQty = 0;
      let grandTotalAmt = 0;

      salesReport.forEach((companyData) => {
         if (isStaticReportType) {
            if (reportType === REPORT_TYPE.party || reportType === 'party') {
               // For party report type
               const companyQty = companyData.data?.reduce((sum, account) => sum + (account.totalQty1 || 0), 0) || 0;
               const companyAmt = companyData.data?.reduce((sum, account) => sum + (account.totalNetAmt || 0), 0) || 0;
               grandTotalQty += companyQty;
               grandTotalAmt += companyAmt;
            } else {
               // For date/broker report type
               const itemData = companyData.data?.flatMap((item) => item.data || []) || [];
               const companyQty = itemData.reduce((sum, trans) => sum + (Number(trans.totalQty1) || 0), 0);
               const companyAmt = itemData.reduce((sum, trans) => sum + (Number(trans.netAmount) || 0), 0);
               grandTotalQty += companyQty;
               grandTotalAmt += companyAmt;
            }
         } else {
            // For dynamic formats
            const transactions = companyData.data || [];
            const companyQty = transactions.reduce((sum, trans) => {
               if (formatType === 'with_item_detail' && trans.purchaseLineItems) {
                  return sum + trans.purchaseLineItems.reduce((itemSum, item) => itemSum + (Number(item.qty1) || 0), 0);
               }
               return sum + (Number(trans.totalQty1) || 0);
            }, 0);

            const companyAmt = transactions.reduce((sum, trans) => {
               if (formatType === 'with_item_detail' && trans.purchaseLineItems) {
                  return sum + trans.purchaseLineItems.reduce((itemSum, item) => itemSum + (Number(item.netAmt) || 0), 0);
               }
               return sum + (Number(trans.netAmount) || 0);
            }, 0);

            grandTotalQty += companyQty;
            grandTotalAmt += companyAmt;
         }
      });

      return { grandTotalQty, grandTotalAmt };
   }, [salesReport, reportType, formatType, isStaticReportType]);

   const downloadExcel = useCallback(() => {
      if (!salesReport || salesReport.length === 0) {
         alert('No data available to export');
         return;
      }

      try {
         const wb = XLSX.utils.book_new();

         // Enhanced date parser that handles multiple formats
         const parseDate = (dateValue) => {
            if (!dateValue) return null;

            // If it's already a proper Date object
            if (dateValue instanceof Date && !isNaN(dateValue.getTime())) {
               return dateValue;
            }

            // If it's a timestamp (number or string representation)
            if (!isNaN(dateValue)) {
               const timestamp = Number(dateValue);
               // Check if it's milliseconds (13 digits) or seconds (10 digits)
               const date = timestamp > 9999999999 ? new Date(timestamp) : new Date(timestamp * 1000);
               if (!isNaN(date.getTime())) return date;
            }

            // If it's a string in ISO format (e.g., "2025-07-31T00:00:00.000Z")
            if (typeof dateValue === 'string' && dateValue.includes('T')) {
               const date = new Date(dateValue);
               if (!isNaN(date.getTime())) return date;
            }

            // If it's a string in "YYYY-MM-DD" format
            if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
               const [year, month, day] = dateValue.split('-');
               const date = new Date(year, month - 1, day);
               if (!isNaN(date.getTime())) return date;
            }

            // If it's a string in "DD/MM/YYYY" format
            if (typeof dateValue === 'string' && dateValue.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
               const [day, month, year] = dateValue.split('/');
               const date = new Date(year, month - 1, day);
               if (!isNaN(date.getTime())) return date;
            }

            console.warn('Could not parse date:', dateValue);
            return null;
         };

         // Format date for display
         const formatDateStrict = (date) => {
            if (!date) return '-';
            if (typeof date === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(date)) {
               return date;
            }
            const parsedDate = parseDate(date);
            if (parsedDate) {
               return parsedDate
                  .toLocaleDateString('en-GB', {
                     day: '2-digit',
                     month: '2-digit',
                     year: 'numeric',
                  })
                  .replace(/\//g, '-');
            }
            return '-';
         };

         // Check format type
         const isDynamicFormat = dynamicValues && dynamicValues.includes(reportType);
         const selectedFormat = isDynamicFormat ? dynamicOptions?.find((opt) => opt.value === reportType) : null;
         const formatDefName = selectedFormat?.formatData?.defName;

         // Get columns
         const allColumns = getColumnsReportsSalesDetail
            ? getColumnsReportsSalesDetail(formatType, reportType)
            : dynamicColumns;

         // Filter columns similar to PDF logic
         const visibleColumns = allColumns.filter((col) => {
            if (columnVisibility && columnVisibility[col.id] === false) return false;
            if (col.isShow === false) return false;

            if (isTextile && (col.id === 'serialNo' || col.id === 'serial_no' || col.id === 'serialNumber')) {
               return false;
            }

            // Exclude HSN/SAC and Due Days columns for date-based reports
            const isDateBasedReport =
               reportType === REPORT_TYPE.date || reportType === 'date' || formatDefName === 'PurchaseDetailDate';

            if (isDateBasedReport) {
               const columnId = col.id?.toLowerCase() || '';
               const columnHeader = col.header?.toLowerCase() || '';

               if (
                  columnId.includes('hsn') ||
                  columnId.includes('sac') ||
                  columnHeader.includes('hsn') ||
                  columnHeader.includes('sac') ||
                  columnId.includes('due') ||
                  columnHeader.includes('due')
               ) {
                  return false;
               }
            }

            return true;
         });

         const sortedColumns = visibleColumns.sort((a, b) => {
            const orderA = a.orderNo || 0;
            const orderB = b.orderNo || 0;
            return orderA - orderB;
         });

         // Enhanced serial number extraction
         const getSerialNumber = (transaction, itemIndex = 0, isMultiItemMode = false) => {
            try {
               const serialFields = ['serialNo', 'serial_no', 'serialNumber', 'serial_number', 'serials', 'serialNos'];

               let serialValue = null;

               // For multi-item mode, get serial from specific item
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const item = transaction.purchaseLineItems[itemIndex];
                  for (const field of serialFields) {
                     if (item[field] !== undefined && item[field] !== null) {
                        serialValue = item[field];
                        break;
                     }
                  }
               }

               // Fallback to transaction level or first item
               if (!serialValue) {
                  for (const field of serialFields) {
                     if (transaction[field] !== undefined && transaction[field] !== null) {
                        serialValue = transaction[field];
                        break;
                     }
                  }

                  if (!serialValue && transaction.purchaseLineItems && Array.isArray(transaction.purchaseLineItems)) {
                     for (const lineItem of transaction.purchaseLineItems) {
                        for (const field of serialFields) {
                           if (lineItem[field] !== undefined && lineItem[field] !== null) {
                              serialValue = lineItem[field];
                              break;
                           }
                        }
                        if (serialValue) break;
                     }
                  }
               }

               if (serialValue !== null && serialValue !== undefined) {
                  if (Array.isArray(serialValue)) {
                     const filteredSerials = serialValue.filter((s) => s !== null && s !== undefined && s !== '');
                     return filteredSerials.length > 0 ? filteredSerials.join(', ') : 'No Serial';
                  } else if (typeof serialValue === 'string' || typeof serialValue === 'number') {
                     const serialStr = String(serialValue).trim();
                     return serialStr && serialStr !== '' ? serialStr : 'No Serial';
                  }
               }

               return 'No Serial';
            } catch (error) {
               console.error('Error getting serial number:', error);
               return 'Error';
            }
         };

         // Enhanced cell value extraction with multi-item support
         const getCellValue = (transaction, column, itemIndex = 0, isMultiItemMode = false) => {
            const accessor = column.accessor || column.id;
            let value = '';

            try {
               if (column.id === 'transactionAt') {
                  if (isMultiItemMode && itemIndex > 0) {
                     return '';
                  }
                  return formatDateStrict(transaction[accessor] || transaction.date || transaction.transactionDate);
               } else if (column.id === 'docno') {
                  if (isMultiItemMode && itemIndex > 0) {
                     return '';
                  }
                  const docno = transaction.docno || '';
                  const prefix = transaction.prefix || '';
                  const postFix = transaction.postFix || transaction.suffix || '';
                  return docno ? `${prefix}${docno}${postFix}` : '';
               } else if (column.id === 'itemName' || column.id === 'item_name') {
                  if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                     return transaction.purchaseLineItems[itemIndex].itemName || '';
                  }
                  return (
                     transaction.itemName || transaction.item_name || transaction.purchaseLineItems?.[0]?.itemName || ''
                  );
               } else if (column.id === 'serialNo' || column.id === 'serial_no') {
                  return getSerialNumber(transaction, itemIndex, isMultiItemMode);
               } else if (column.id === 'hsnSac') {
                  if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                     return transaction.purchaseLineItems[itemIndex].hsnSac || '';
                  }
                  return transaction.purchaseLineItems?.[0]?.hsnSac || '';
               } else if (column.id === 'itemRate') {
                  if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                     return Number(transaction.purchaseLineItems[itemIndex].itemRate || 0);
                  }
                  return Number(transaction.purchaseLineItems?.[0]?.itemRate || 0);
               } else if (column.id === 'totalQty1') {
                  if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                     return Number(transaction.purchaseLineItems[itemIndex].qty1 || 0);
                  } else if (
                     formatType === 'with_item_detail' &&
                     transaction.purchaseLineItems &&
                     transaction.purchaseLineItems.length > 0
                  ) {
                     return Number(transaction.purchaseLineItems[0].qty1 || 0);
                  }
                  return Number(transaction.totalQty1 || 0);
               } else if (column.id === 'lineNetAmount') {
                  if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                     return Number(transaction.purchaseLineItems[itemIndex].netAmt || 0);
                  } else if (
                     formatType === 'with_item_detail' &&
                     transaction.purchaseLineItems &&
                     transaction.purchaseLineItems.length > 0
                  ) {
                     return Number(transaction.purchaseLineItems[0].netAmt || 0);
                  }
                  return 0;
               } else if (
                  ['netAmount', 'billAmount', 'basicAmount', 'taxableAmount', 'gstAmount'].includes(column.id)
               ) {
                  if (isMultiItemMode && itemIndex > 0) {
                     return '';
                  }
                  let numValue = 0;
                  if (column.id === 'billAmount') {
                     numValue = Number(transaction.billAmount || transaction.netAmount || 0);
                  } else {
                     numValue = Number(transaction[column.id] || 0);
                  }
                  return numValue;
               } else if (['qty1', 'quantity'].includes(column.id)) {
                  if (isMultiItemMode && itemIndex > 0) {
                     return '';
                  }
                  return Number(transaction[column.id] || 0);
               } else {
                  // For non-item specific columns in multi-item mode, only show on first item
                  const nonItemColumns = ['accountname', 'daybookname', 'mobile', 'brokername', 'notes', 'dueDays'];
                  if (isMultiItemMode && itemIndex > 0 && nonItemColumns.includes(column.id)) {
                     return '';
                  }
                  const possibleFields = [accessor, column.id, accessor.replace(/([A-Z])/g, '_$1').toLowerCase()];
                  for (const field of possibleFields) {
                     if (transaction[field] !== undefined && transaction[field] !== null) {
                        return String(transaction[field]);
                     }
                  }
               }
            } catch (error) {
               console.error('Error getting cell value:', error);
            }

            return value || '';
         };

         // Extract all transactions from company data
         const extractAllTransactions = (companyData) => {
            const transactions = [];

            const findTransactions = (obj, path = '') => {
               if (!obj || typeof obj !== 'object') return;

               if (Array.isArray(obj)) {
                  obj.forEach((item, index) => {
                     if (
                        item &&
                        typeof item === 'object' &&
                        (item.billNo ||
                           item.docno ||
                           item.transactionAt ||
                           item.accountName ||
                           item.netAmount ||
                           item.itemName ||
                           item.basicAmount ||
                           item.partyName ||
                           item.brokerName)
                     ) {
                        transactions.push(item);
                     } else {
                        findTransactions(item, `${path}[${index}]`);
                     }
                  });
               } else {
                  Object.keys(obj).forEach((key) => {
                     findTransactions(obj[key], `${path}.${key}`);
                  });
               }
            };

            findTransactions(companyData.data);
            return transactions;
         };

         // Create Excel cell with proper formatting
         const createExcelCell = (value, column, isHeader = false) => {
            if (isHeader) {
               return {
                  v: column.header || column.id,
                  t: 's',
                  s: {
                     font: { bold: true, color: { rgb: column.color ? column.color.replace('#', '') : '000000' } },
                     fill: { fgColor: { rgb: 'D3D3D3' } },
                     alignment: { horizontal: 'center' },
                  },
               };
            }

            // Handle date formatting
            if (column.id === 'transactionAt' && value && value !== '-') {
               const date = parseDate(value);
               if (date) {
                  return {
                     v: date,
                     t: 'd',
                     s: { numFmt: 'dd-mm-yyyy' },
                  };
               }
            }

            // Handle numeric values
            if (
               column.isNumeric ||
               [
                  'netAmount',
                  'basicAmount',
                  'taxableAmount',
                  'gstAmount',
                  'itemRate',
                  'totalQty1',
                  'lineNetAmount',
               ].includes(column.id)
            ) {
               const numValue = Number(value);
               if (!isNaN(numValue)) {
                  return {
                     v: numValue,
                     t: 'n',
                     s: {
                        numFmt: column.id.toLowerCase().includes('qty') ? '#,##0' : '#,##0.00',
                        alignment: { horizontal: 'right' },
                        font: { color: { rgb: column.color ? column.color.replace('#', '') : '000000' } },
                     },
                  };
               }
            }

            // Default string formatting
            return {
               v: value || '',
               t: 's',
               s: {
                  font: { color: { rgb: column.color ? column.color.replace('#', '') : '000000' } },
               },
            };
         };

         // Process each company's data
         salesReport.forEach((companyData) => {
            if (!companyData) return;

            const companyName = companyData.companyName || `Company_${Math.random().toString(36).substring(2, 7)}`;
            const wsData = [];
            const merges = [];
            let currentRow = 0;

            // Determine if we should use dynamic or static processing
            if (isDynamicFormat) {
               // DYNAMIC FORMAT PROCESSING
               const allTransactions = extractAllTransactions(companyData);

               // Add company header with totals
               const companyTotal = allTransactions.reduce((sum, trans) => {
                  const amount = getCellValue(trans, { id: 'netAmount', isNumeric: true });
                  return sum + (Number(amount) || 0);
               }, 0);

               const totalQty = allTransactions.reduce((sum, trans) => {
                  const qty = getCellValue(trans, { id: 'totalQty1', isNumeric: true });
                  return sum + (Number(qty) || 0);
               }, 0);

               wsData.push([
                  {
                     v: `${companyName} (Qty: ${totalQty.toLocaleString()}, Total: ₹${companyTotal.toLocaleString()})`,
                     t: 's',
                     s: {
                        font: { bold: true, sz: 12 },
                        fill: { fgColor: { rgb: 'F1F0E8' } },
                        alignment: { horizontal: 'center' },
                     },
                  },
               ]);

               merges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: sortedColumns.length - 1 } });
               currentRow++;

               wsData.push([]); // Empty row
               currentRow++;

               if (formatDefName === 'PurchaseDetailParty') {
                  // Group by party
                  const groupedByParty = {};
                  allTransactions.forEach((trans) => {
                     const party = trans.accountname || trans.partyName || trans.party_name || 'Unknown Party';
                     if (!groupedByParty[party]) groupedByParty[party] = [];
                     groupedByParty[party].push(trans);
                  });

                  Object.entries(groupedByParty).forEach(([partyName, partyTrans]) => {
                     const partyTotal = partyTrans.reduce((sum, trans) => {
                        const amount = getCellValue(trans, { id: 'netAmount', isNumeric: true });
                        return sum + (Number(amount) || 0);
                     }, 0);

                     const partyQty = partyTrans.reduce((sum, trans) => {
                        const qty = getCellValue(trans, { id: 'totalQty1', isNumeric: true });
                        return sum + (Number(qty) || 0);
                     }, 0);

                     // Party header
                     wsData.push([
                        {
                           v: `${partyName} (Qty: ${partyQty.toLocaleString()}, Amount: ₹${partyTotal.toLocaleString()})`,
                           t: 's',
                           s: {
                              font: { bold: true },
                              fill: { fgColor: { rgb: 'F5EEE6' } },
                              alignment: { horizontal: 'center' },
                           },
                        },
                     ]);
                     merges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: sortedColumns.length - 1 } });
                     currentRow++;

                     // Column headers
                     wsData.push(sortedColumns.map((col) => createExcelCell(null, col, true)));
                     currentRow++;

                     // Transaction data
                     partyTrans.forEach((transaction) => {
                        if (
                           formatType === 'with_item_detail' &&
                           transaction.purchaseLineItems &&
                           transaction.purchaseLineItems.length > 1
                        ) {
                           transaction.purchaseLineItems.forEach((item, itemIndex) => {
                              const row = sortedColumns.map((col) =>
                                 createExcelCell(getCellValue(transaction, col, itemIndex, true), col),
                              );
                              wsData.push(row);
                              currentRow++;
                           });
                        } else {
                           const row = sortedColumns.map((col) => createExcelCell(getCellValue(transaction, col), col));
                           wsData.push(row);
                           currentRow++;
                        }
                     });

                     wsData.push([]); // Empty row after party
                     currentRow++;
                  });
               } else if (formatDefName === 'PurchaseDetailDate') {
                  // Group by date
                  const groupedByDate = {};
                  allTransactions.forEach((trans) => {
                     const date =
                        formatDateStrict(trans.transactionAt || trans.date || trans.transaction_date) || 'No Date';
                     if (!groupedByDate[date]) groupedByDate[date] = [];
                     groupedByDate[date].push(trans);
                  });

                  // Add column headers once for date format
                  wsData.push(sortedColumns.map((col) => createExcelCell(null, col, true)));
                  currentRow++;

                  Object.entries(groupedByDate).forEach(([date, dateTrans]) => {
                     const dateTotal = dateTrans.reduce((sum, trans) => {
                        const amount = getCellValue(trans, { id: 'netAmount', isNumeric: true });
                        return sum + (Number(amount) || 0);
                     }, 0);

                     const dateQty = dateTrans.reduce((sum, trans) => {
                        const qty = getCellValue(trans, { id: 'totalQty1', isNumeric: true });
                        return sum + (Number(qty) || 0);
                     }, 0);

                     // Date header
                     wsData.push([
                        {
                           v: `${date} (Qty: ${dateQty.toLocaleString()}, Amount: ₹${dateTotal.toLocaleString()})`,
                           t: 's',
                           s: {
                              font: { bold: true },
                              fill: { fgColor: { rgb: 'E5E5E5' } },
                              alignment: { horizontal: 'center' },
                           },
                        },
                     ]);
                     merges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: sortedColumns.length - 1 } });
                     currentRow++;

                     // Transaction data
                     dateTrans.forEach((transaction) => {
                        if (
                           formatType === 'with_item_detail' &&
                           transaction.purchaseLineItems &&
                           transaction.purchaseLineItems.length > 1
                        ) {
                           transaction.purchaseLineItems.forEach((item, itemIndex) => {
                              const row = sortedColumns.map((col) =>
                                 createExcelCell(getCellValue(transaction, col, itemIndex, true), col),
                              );
                              wsData.push(row);
                              currentRow++;
                           });
                        } else {
                           const row = sortedColumns.map((col) => createExcelCell(getCellValue(transaction, col), col));
                           wsData.push(row);
                           currentRow++;
                        }
                     });
                  });
               } else {
                  // Default dynamic format - just list all transactions
                  wsData.push(sortedColumns.map((col) => createExcelCell(null, col, true)));
                  currentRow++;

                  allTransactions.forEach((transaction) => {
                     if (
                        formatType === 'with_item_detail' &&
                        transaction.purchaseLineItems &&
                        transaction.purchaseLineItems.length > 1
                     ) {
                        transaction.purchaseLineItems.forEach((item, itemIndex) => {
                           const row = sortedColumns.map((col) =>
                              createExcelCell(getCellValue(transaction, col, itemIndex, true), col),
                           );
                           wsData.push(row);
                           currentRow++;
                        });
                     } else {
                        const row = sortedColumns.map((col) => createExcelCell(getCellValue(transaction, col), col));
                        wsData.push(row);
                        currentRow++;
                     }
                  });
               }
            } else {
               // STATIC FORMAT PROCESSING
               if (reportType === REPORT_TYPE.party || reportType === 'party') {
                  // Add company header with totals
                  const companyTotal =
                     companyData.data?.reduce((sum, account) => sum + (account.totalNetAmt || 0), 0) || 0;
                  const totalQty = companyData.data?.reduce((sum, account) => sum + (account.totalQty1 || 0), 0) || 0;

                  wsData.push([
                     {
                        v: `${companyName} (Qty: ${totalQty.toLocaleString()}, Total: ₹${companyTotal.toLocaleString()})`,
                        t: 's',
                        s: {
                           font: { bold: true, sz: 12 },
                           fill: { fgColor: { rgb: 'F1F0E8' } },
                           alignment: { horizontal: 'center' },
                        },
                     },
                  ]);
                  merges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: sortedColumns.length - 1 } });
                  currentRow++;

                  wsData.push([]); // Empty row
                  currentRow++;

                  // Process each account
                  companyData.data?.forEach((accountData) => {
                     if (!accountData) return;

                     const accountTotal = accountData.totalNetAmt || 0;
                     const accountQty = accountData.totalQty1 || 0;

                     // Add account header
                     wsData.push([
                        {
                           v: `${accountData.accountName
                              } (Qty: ${accountQty.toLocaleString()}, Amount: ₹${accountTotal.toLocaleString()})`,
                           t: 's',
                           s: {
                              font: { bold: true },
                              fill: { fgColor: { rgb: 'F5EEE6' } },
                              alignment: { horizontal: 'center' },
                           },
                        },
                     ]);
                     merges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: sortedColumns.length - 1 } });
                     currentRow++;

                     // Add column headers
                     wsData.push(sortedColumns.map((col) => createExcelCell(null, col, true)));
                     currentRow++;

                     // Add transaction data
                     accountData.data?.forEach((transaction) => {
                        if (!transaction) return;

                        if (
                           formatType === 'with_item_detail' &&
                           transaction.purchaseLineItems &&
                           transaction.purchaseLineItems.length > 1
                        ) {
                           transaction.purchaseLineItems.forEach((item, itemIndex) => {
                              const row = sortedColumns.map((col) =>
                                 createExcelCell(getCellValue(transaction, col, itemIndex, true), col),
                              );
                              wsData.push(row);
                              currentRow++;
                           });
                        } else {
                           const row = sortedColumns.map((col) => createExcelCell(getCellValue(transaction, col), col));
                           wsData.push(row);
                           currentRow++;
                        }
                     });

                     wsData.push([]); // Empty row after account
                     currentRow++;
                  });
               } else {
                  // For date/broker report type
                  const allDateTransactions = companyData.data?.flatMap((item) => item.data || []) || [];

                  const companyTotal = allDateTransactions.reduce((sum, trans) => {
                     return sum + (Number(trans.netAmount) || 0);
                  }, 0);

                  const totalQty = allDateTransactions.reduce((sum, trans) => {
                     return sum + (Number(trans.totalQty1) || 0);
                  }, 0);

                  wsData.push([
                     {
                        v: `${companyName} (Qty: ${totalQty.toLocaleString()}, Total: ₹${companyTotal.toLocaleString()})`,
                        t: 's',
                        s: {
                           font: { bold: true, sz: 12 },
                           fill: { fgColor: { rgb: 'F1F0E8' } },
                           alignment: { horizontal: 'center' },
                        },
                     },
                  ]);
                  merges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: sortedColumns.length - 1 } });
                  currentRow++;

                  wsData.push([]); // Empty row
                  currentRow++;

                  // Group by date
                  const groupedByDate = {};
                  allDateTransactions.forEach((trans) => {
                     const date = parseDate(trans.transactionAt);
                     const dateStr = date ? date.toLocaleDateString('en-GB') : 'No Date';
                     if (!groupedByDate[dateStr]) groupedByDate[dateStr] = [];
                     groupedByDate[dateStr].push(trans);
                  });

                  // Add column headers once
                  wsData.push(sortedColumns.map((col) => createExcelCell(null, col, true)));
                  currentRow++;

                  Object.entries(groupedByDate).forEach(([date, dateTransactions]) => {
                     const dateTotal = dateTransactions.reduce((sum, trans) => {
                        return sum + (Number(trans.netAmount) || 0);
                     }, 0);

                     const dateQty = dateTransactions.reduce((sum, trans) => {
                        return sum + (Number(trans.totalQty1) || 0);
                     }, 0);

                     // Add date header
                     wsData.push([
                        {
                           v: `${date} (Qty: ${dateQty.toLocaleString()}, Amount: ₹${dateTotal.toLocaleString()})`,
                           t: 's',
                           s: {
                              font: { bold: true },
                              fill: { fgColor: { rgb: 'E5E5E5' } },
                              alignment: { horizontal: 'center' },
                           },
                        },
                     ]);
                     merges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: sortedColumns.length - 1 } });
                     currentRow++;

                     // Add transaction rows
                     dateTransactions.forEach((transaction) => {
                        if (
                           formatType === 'with_item_detail' &&
                           transaction.purchaseLineItems &&
                           transaction.purchaseLineItems.length > 1
                        ) {
                           transaction.purchaseLineItems.forEach((item, itemIndex) => {
                              const row = sortedColumns.map((col) =>
                                 createExcelCell(getCellValue(transaction, col, itemIndex, true), col),
                              );
                              wsData.push(row);
                              currentRow++;
                           });
                        } else {
                           const row = sortedColumns.map((col) => createExcelCell(getCellValue(transaction, col), col));
                           wsData.push(row);
                           currentRow++;
                        }
                     });
                  });
               }
            }

            // Create worksheet
            const ws = XLSX.utils.aoa_to_sheet(wsData);

            // Apply merges
            if (merges.length > 0) {
               ws['!merges'] = merges;
            }

            // Set column widths based on content
            const colWidths = sortedColumns.map((col) => {
               if (col.id === 'transactionAt') return { wch: 12 };
               if (
                  ['netAmount', 'billAmount', 'basicAmount', 'taxableAmount', 'gstAmount', 'itemRate'].includes(col.id)
               ) {
                  return { wch: 15 };
               }
               if (col.id === 'itemName') return { wch: 25 };
               if (col.id === 'accountName' || col.id === 'accountname') return { wch: 20 };
               if (col.id === 'serialNo' || col.id === 'serial_no') return { wch: 20 };
               if (col.id === 'docno') return { wch: 12 };

               const maxContentLength = Math.max(
                  col.header?.length || col.id.length,
                  15, // minimum width
               );

               return { wch: Math.min(Math.max(maxContentLength, 10), 30) };
            });

            ws['!cols'] = colWidths;

            // Add worksheet to workbook with safe sheet name
            const safeSheetName = companyName.substring(0, 31).replace(/[\\/*[\]:?]/g, '');
            XLSX.utils.book_append_sheet(wb, ws, safeSheetName);
         });

         // Generate and download the Excel file with timestamp
         const formatName = isDynamicFormat
            ? dynamicOptions?.find((opt) => opt.value === reportType)?.label || reportType
            : staticReportTypeOptions?.find((opt) => opt.value === reportType)?.label || reportType;

         const fileName = `${formatName}_Purchase_Detail_Report_${moment().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;
         XLSX.writeFile(wb, fileName);
      } catch (error) {
         console.error('Error generating Excel file:', error);
         alert('Error generating Excel file. Please check console for details.');
      }
   }, [
      salesReport,
      reportType,
      dynamicColumns,
      columnVisibility,
      formatType,
      dynamicValues,
      dynamicOptions,
      getColumnsReportsSalesDetail,
      staticReportTypeOptions,
      isTextile
   ]);

   const downloadPDF = useCallback(() => {
      if (!salesReport || salesReport.length === 0) {
         alert('No data available to export');
         return;
      }

      const doc = new jsPDF({
         orientation: 'landscape',
         unit: 'mm',
      });

      const formatDateStrict = (date) => {
         if (!date) return '-';
         if (typeof date === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(date)) {
            return date;
         }
         const m = moment(date);
         return m.isValid() ? m.format('DD-MM-YYYY') : '-';
      };

      // Color conversion utility (added from sales PDF)
      const convertBackendColor = (backendColor) => {
         if (!backendColor) return [0, 0, 0]; // Default black
         if (backendColor.startsWith('#')) {
            // Convert hex to RGB array for jsPDF
            const hex = backendColor.substring(1);
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);
            return [r, g, b];
         }
         if (backendColor.startsWith('0xff')) {
            const hex = backendColor.substring(4);
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);
            return [r, g, b];
         }
         if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) {
            const r = parseInt(backendColor.substring(0, 2), 16);
            const g = parseInt(backendColor.substring(2, 4), 16);
            const b = parseInt(backendColor.substring(4, 6), 16);
            return [r, g, b];
         }
         return [0, 0, 0]; // Default black
      };

      // Add title
      const title = `Purchase Detail Report (${formatDateStrict(dateRange.fromDate)} to ${formatDateStrict(
         dateRange.toDate,
      )})`;
      doc.setFontSize(14);

      // Calculate center position for title
      const pdfWidth = doc.internal.pageSize.getWidth();
      const titleWidth = (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
      const titleXPosition = (pdfWidth - titleWidth) / 2;
      doc.text(title, titleXPosition, 10);

      // Add company filter info
      if (companyFilter && companyFilter.length > 0) {
         const companyNames = companyFilter
            .map((id) => {
               const company = companyList?.find((c) => c.id === id);
               return company ? company.name : '';
            })
            .filter((name) => name !== '')
            .join(', ');

         if (companyNames) {
            const companyText = `Companies: ${companyNames}`;
            doc.setFontSize(8);
            const companyWidth =
               (doc.getStringUnitWidth(companyText) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
            const companyXPosition = (pdfWidth - companyWidth) / 2;
            doc.text(companyText, companyXPosition, 15);
         }
      }

      // Add report type info
      const reportTypeText = `Report Type: ${staticReportTypeOptions?.find((opt) => opt.value === reportType)?.label || reportType
         }`;
      doc.setFontSize(8);
      const reportTypeWidth =
         (doc.getStringUnitWidth(reportTypeText) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
      const reportTypeXPosition = (pdfWidth - reportTypeWidth) / 2;
      doc.text(reportTypeText, reportTypeXPosition, 20);

      // Check format type
      const isDynamicFormat = dynamicValues && dynamicValues.includes(reportType);
      const selectedFormat = isDynamicFormat ? dynamicOptions?.find((opt) => opt.value === reportType) : null;
      const formatDefName = selectedFormat?.formatData?.defName;

      // Get columns
      const allColumns = getColumnsReportsSalesDetail
         ? getColumnsReportsSalesDetail(formatType, reportType)
         : dynamicColumns;

      // Filter out HSN/SAC and Due Days columns for date-based reports
      const visibleColumns = allColumns.filter((col) => {
         if (columnVisibility && columnVisibility[col.id] === false) return false;
         if (col.isShow === false) return false;
         if (isTextile && (col.id === 'serialNo' || col.id === 'serial_no' || col.id === 'serialNumber')) {
            return false;
         }

         // Exclude HSN/SAC and Due Days columns for date-based reports
         const isDateBasedReport =
            reportType === REPORT_TYPE.date || reportType === 'date' || formatDefName === 'PurchaseDetailDate';

         if (isDateBasedReport) {
            const columnId = col.id?.toLowerCase() || '';
            const columnHeader = col.header?.toLowerCase() || '';

            if (
               columnId.includes('hsn') ||
               columnId.includes('sac') ||
               columnHeader.includes('hsn') ||
               columnHeader.includes('sac') ||
               columnId.includes('due') ||
               columnHeader.includes('due')
            ) {
               return false;
            }
         }

         return true;
      });

      const sortedColumns = visibleColumns.sort((a, b) => {
         const orderA = a.orderNo || 0;
         const orderB = b.orderNo || 0;
         return orderA - orderB;
      });

      // Calculate widths
      const totalFlex = sortedColumns.reduce((sum, col) => sum + (col.flex || 1), 0);
      const pageWidth = doc.internal.pageSize.getWidth() - 20;

      const calculateColumnWidth = (column) => {
         const baseFlex = column.flex || 1;

         // Enhanced width calculation for static format only
         if (!isDynamicFormat) {
            // Priority 1: Party/Account name columns (highest priority)
            const isPartyColumn = column.id === 'accountname' || column.id === 'accountName';

            if (isPartyColumn) {
               // Increase party column width by 60% more than normal calculation
               return Math.min((pageWidth * baseFlex * 1.6) / totalFlex, pageWidth * 0.25); // Max 25% of page width
            }

            // Priority 2: Item name columns (high priority)
            const isItemColumn = column.id === 'itemName';

            if (isItemColumn) {
               return Math.min((pageWidth * baseFlex * 1.4) / totalFlex, pageWidth * 0.22); // Max 22% of page width
            }

            // Priority 3: Daybook columns (high priority)
            const isDaybookColumn = column.id === 'daybookname';

            if (isDaybookColumn) {
               return Math.min((pageWidth * baseFlex * 1.3) / totalFlex, pageWidth * 0.18); // Max 18% of page width
            }

            // Priority 4: Serial Number columns - increased width for multi-line display
            const isSerialColumn =
               column.id === 'serialNo' || column.id === 'serial_no' || column.id === 'serialNumber';

            if (isSerialColumn) {
               return Math.min((pageWidth * baseFlex * 1.2) / totalFlex, pageWidth * 0.15); // Increased to 15% for multi-line serials
            }

            // Priority 5: Compressible columns (lower priority - can be reduced)
            const isCompressibleColumn = column.id === 'docno';

            if (isCompressibleColumn) {
               return Math.min((pageWidth * baseFlex * 0.6) / totalFlex, pageWidth * 0.08); // Reduced to max 8% of page width
            }

            // Priority 6: Quantity columns (can be compressed)
            const isQuantityColumn = column.id === 'totalQty1';

            if (isQuantityColumn) {
               return Math.min((pageWidth * baseFlex * 0.7) / totalFlex, pageWidth * 0.1); // Reduced to max 10% of page width
            }

            // Priority 7: Amount columns (can be compressed)
            const isAmountColumn =
               column.id === 'netAmount' ||
               (column.isNumeric &&
                  (column.header?.toLowerCase().includes('amount') || column.header?.toLowerCase().includes('amt')));

            if (isAmountColumn) {
               return Math.min((pageWidth * baseFlex * 0.8) / totalFlex, pageWidth * 0.12); // Reduced to max 12% of page width
            }

            const isRateColumn =
               column.id === 'itemRate' ||
               (column.isNumeric &&
                  (column.header?.toLowerCase().includes('amount') || column.header?.toLowerCase().includes('amt')));

            if (isRateColumn) {
               return Math.min((pageWidth * baseFlex * 0.8) / totalFlex, pageWidth * 0.2);
            }

            // Priority 8: Other important text columns (medium priority)
            const isImportantTextColumn =
               column.id === 'mobile' ||
               column.id === 'phone' ||
               column.id === 'brokername' ||
               column.id === 'brokerName' ||
               column.id === 'broker_name' ||
               column.id === 'notes' ||
               column.id === 'remarks' ||
               column.id === 'description';

            if (isImportantTextColumn) {
               return Math.min((pageWidth * baseFlex * 0.9) / totalFlex, pageWidth * 0.15); // Max 15% of page width
            }

            // Priority 9: Date columns (standard width)
            const isDateColumn = column.id === 'transactionAt' || column.id === 'transaction_at';

            if (isDateColumn) {
               return Math.min((pageWidth * baseFlex * 0.9) / totalFlex, pageWidth * 0.12); // Standard date width
            }

            // Default for other non-numeric columns - slightly reduced to compensate for priority columns
            if (!column.isNumeric) {
               return (pageWidth * baseFlex * 0.85) / totalFlex;
            }
         }

         // Default calculation for dynamic format or fallback
         return (pageWidth * baseFlex) / totalFlex;
      };

      // Enhanced columnStyles with improved serial number column styling
      const columnStyles = {};
      sortedColumns.forEach((col, index) => {
         const textColor = col.color ? convertBackendColor(col.color) : [0, 0, 0];
         const fontStyle =
            col.isBold && col.isItalic ? 'bolditalic' : col.isBold ? 'bold' : col.isItalic ? 'italic' : 'normal';

         // Check column types for special styling
         const isPartyColumn = col.id === 'accountname' || col.id === 'accountName';
         const isItemColumn = col.id === 'itemName';
         const isDaybookColumn = col.id === 'daybookname';
         const isSerialColumn = col.id === 'serialNo' || col.id === 'serial_no' || col.id === 'serialNumber';

         const isCompressibleColumn =
            col.id === 'docno' ||
            col.id === 'docNo' ||
            col.id === 'billno' ||
            col.id === 'billNo' ||
            col.id === 'qty' ||
            col.id === 'totalQty1' ||
            col.id === 'netAmount' ||
            col.id === 'billAmount' ||
            col.id === 'basicAmount';

         columnStyles[index] = {
            cellWidth: calculateColumnWidth(col),
            halign: col.isNumeric ? 'right' : 'left',
            cellPadding:
               isPartyColumn || isItemColumn || isDaybookColumn || isSerialColumn
                  ? 1.5
                  : isCompressibleColumn
                     ? 0.8
                     : 1,
            textColor: textColor,
            fontStyle: fontStyle,
            fontSize:
               isPartyColumn || isItemColumn || isDaybookColumn || isSerialColumn ? 8 : isCompressibleColumn ? 7 : 8,
            overflow: 'linebreak', // Allow text wrapping for important columns
            valign: 'top', // Changed from 'middle' to 'top' for better multi-line display
            // Add minimum width enforcement for priority columns
            minCellWidth: isPartyColumn
               ? 35
               : isItemColumn
                  ? 30
                  : isDaybookColumn
                     ? 25
                     : isSerialColumn
                        ? 20
                        : undefined,
         };
      });

      // Enhanced cell value function with multi-line serial number support
      const getCellValue = (transaction, column, itemIndex = 0, isMultiItemMode = false) => {
         const accessor = column.accessor || column.id;
         let value = '';

         try {
            if (column.id === 'transactionAt') {
               // For multi-item mode, only show date on first item
               if (isMultiItemMode && itemIndex > 0) {
                  value = '';
               } else {
                  value = formatDateStrict(transaction[accessor] || transaction.date || transaction.transactionDate);
               }
            } else if (column.id === 'docno') {
               // For multi-item mode, only show document number on first item
               if (isMultiItemMode && itemIndex > 0) {
                  value = '';
               } else {
                  const docno = transaction.docno || '';
                  const prefix = transaction.prefix || '';
                  const postFix = transaction.postFix || transaction.suffix || '';
                  value = docno ? `${prefix}${docno}${postFix}` : '';
               }
            } else if (column.id === 'itemName' || column.id === 'item_name') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  value = transaction.purchaseLineItems[itemIndex].itemName || '';
               } else {
                  value =
                     transaction.itemName ||
                     transaction.item_name ||
                     transaction.purchaseLineItems?.[0]?.itemName ||
                     '';
               }
               value = String(value).replace(/\s+/g, ' ').substring(0, 40);
            } else if (column.id === 'serialNo' || column.id === 'serial_no' || column.id === 'serialNumber') {
               // Enhanced serial number handling for multi-line display
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const item = transaction.purchaseLineItems[itemIndex];
                  const serialNos = Array.isArray(item.serialNo) ? item.serialNo : [];

                  if (serialNos.length > 0) {
                     // Join serial numbers with newlines for multi-line display
                     value = serialNos.join('\n');
                  } else {
                     value = 'No Serial';
                  }
               } else {
                  // Original serial number extraction logic with multi-line support
                  let serialNos = [];

                  if (transaction.serialNo) {
                     serialNos = Array.isArray(transaction.serialNo)
                        ? transaction.serialNo
                        : [String(transaction.serialNo)];
                  } else if (transaction.serial_no) {
                     serialNos = Array.isArray(transaction.serial_no)
                        ? transaction.serial_no
                        : [String(transaction.serial_no)];
                  } else if (transaction.serialNumber) {
                     serialNos = Array.isArray(transaction.serialNumber)
                        ? transaction.serialNumber
                        : [String(transaction.serialNumber)];
                  } else if (transaction.purchaseLineItems && Array.isArray(transaction.purchaseLineItems)) {
                     serialNos = transaction.purchaseLineItems
                        .map((item) => item.serialNo || item.serial_no || item.serialNumber)
                        .filter((s) => s)
                        .flat();
                  }

                  if (serialNos.length > 0) {
                     // Join serial numbers with newlines for multi-line display
                     // Limit total characters to prevent overflow
                     const maxChars = 200;
                     let result = serialNos.join('\n');
                     if (result.length > maxChars) {
                        result = result.substring(0, maxChars) + '...';
                     }
                     value = result;
                  } else {
                     value = 'No Serial';
                  }
               }
            } else if (column.id === 'hsnSac') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  value = transaction.purchaseLineItems[itemIndex].hsnSac || '';
               } else {
                  value = transaction.purchaseLineItems?.[0]?.hsnSac || '';
               }
            } else if (column.id === 'itemRate') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const itemRate = transaction.purchaseLineItems[itemIndex].itemRate || 0;
                  value = Number(itemRate).toLocaleString();
               } else {
                  const itemRate = transaction.purchaseLineItems?.[0]?.itemRate || 0;
                  value = Number(itemRate).toLocaleString();
               }
            } else if (column.id === 'totalQty1') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const qty = transaction.purchaseLineItems[itemIndex].qty1 || 0;
                  value = Number(qty).toLocaleString();
               } else if (
                  formatType === 'with_item_detail' &&
                  transaction.purchaseLineItems &&
                  transaction.purchaseLineItems.length > 0
               ) {
                  // For with_item_detail format, show ONLY the first item's quantity
                  value = Number(transaction.purchaseLineItems[0].qty1 || 0).toLocaleString();
               } else {
                  // For other formats, show transaction total quantity
                  value = Number(transaction.totalQty1 || 0).toLocaleString();
               }
            } else if (column.id === 'lineNetAmount') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const netAmt = transaction.purchaseLineItems[itemIndex].netAmt || 0;
                  value = Number(netAmt).toLocaleString();
               } else if (
                  formatType === 'with_item_detail' &&
                  transaction.purchaseLineItems &&
                  transaction.purchaseLineItems.length > 0
               ) {
                  value = Number(transaction.purchaseLineItems[0].netAmt || 0).toLocaleString();
               } else {
                  value = '0';
               }
            } else if (column.id === 'basicAmount') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const basicAmt =
                     transaction.purchaseLineItems[itemIndex].basicAmount ||
                     transaction.purchaseLineItems[itemIndex].netAmt ||
                     0;
                  value = Number(basicAmt).toLocaleString();
               } else if (isMultiItemMode && itemIndex > 0) {
                  value = ''; // Don't show transaction-level amounts on sub-items
               } else {
                  const rawValue = transaction[column.id];
                  if (rawValue !== null && rawValue !== undefined) {
                     const numValue = Number(rawValue);
                     value = isNaN(numValue) ? '0' : numValue.toLocaleString();
                  } else {
                     value = '0';
                  }
               }
            } else if (column.id === 'taxableAmount') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const taxableAmt =
                     transaction.purchaseLineItems[itemIndex].taxableAmount ||
                     transaction.purchaseLineItems[itemIndex].netAmt ||
                     0;
                  value = Number(taxableAmt).toLocaleString();
               } else if (isMultiItemMode && itemIndex > 0) {
                  value = '';
               } else {
                  const rawValue = transaction[column.id];
                  if (rawValue !== null && rawValue !== undefined) {
                     const numValue = Number(rawValue);
                     value = isNaN(numValue) ? '0' : numValue.toLocaleString();
                  } else {
                     value = '0';
                  }
               }
            } else if (column.id === 'gstAmount') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const item = transaction.purchaseLineItems[itemIndex];
                  const gstAmount = (item.cgst || 0) + (item.sgst || 0) + (item.igst || 0) + (item.cess || 0);
                  value = Number(gstAmount).toLocaleString();
               } else if (isMultiItemMode && itemIndex > 0) {
                  value = '';
               } else {
                  const rawValue = transaction[column.id];
                  if (rawValue !== null && rawValue !== undefined) {
                     const numValue = Number(rawValue);
                     value = isNaN(numValue) ? '0' : numValue.toLocaleString();
                  } else {
                     value = '0';
                  }
               }
            } else if (column.isNumeric || ['netAmount', 'billAmount'].includes(column.id)) {
               // For multi-item mode, only show bill/net amounts on first item to avoid duplication
               if (isMultiItemMode && itemIndex > 0) {
                  value = '';
               } else {
                  const possibleFields = [accessor, column.id, accessor.replace(/([A-Z])/g, '_$1').toLowerCase()];
                  let rawValue = null;
                  for (const field of possibleFields) {
                     if (transaction[field] !== undefined && transaction[field] !== null) {
                        rawValue = transaction[field];
                        break;
                     }
                  }
                  if (rawValue !== null && rawValue !== undefined) {
                     const numValue = Number(rawValue);
                     value = isNaN(numValue) ? '0' : numValue.toLocaleString();
                  } else {
                     value = '0';
                  }
               }
            } else {
               // For non-item specific columns in multi-item mode, only show on first item
               const nonItemColumns = ['accountname', 'daybookname', 'mobile', 'brokername', 'notes', 'dueDays'];
               if (isMultiItemMode && itemIndex > 0 && nonItemColumns.includes(column.id)) {
                  value = '';
               } else {
                  const possibleFields = [accessor, column.id, accessor.replace(/([A-Z])/g, '_$1').toLowerCase()];
                  for (const field of possibleFields) {
                     if (transaction[field] !== undefined && transaction[field] !== null) {
                        value = String(transaction[field]);
                        break;
                     }
                  }
               }
            }
         } catch (error) {
            console.error('Error getting cell value:', error);
            value = '';
         }

         return value || '';
      };

      // Enhanced transaction rows creation with multi-line serial number support
      const createPurchaseTransactionRows = (transactions, isMultiItemFormat = false) => {
         const rows = [];

         transactions.forEach((transaction) => {
            const hasMultipleItems =
               isMultiItemFormat &&
               transaction.purchaseLineItems &&
               Array.isArray(transaction.purchaseLineItems) &&
               transaction.purchaseLineItems.length > 1;

            if (hasMultipleItems) {
               // Create separate rows for each item
               transaction.purchaseLineItems.forEach((item, itemIndex) => {
                  const isFirstItem = itemIndex === 0;
                  const isLastItem = itemIndex === transaction.purchaseLineItems.length - 1;

                  const row = sortedColumns.map((col) => {
                     const textColor = col.color ? convertBackendColor(col.color) : [0, 0, 0];
                     const fontStyle =
                        col.isBold && col.isItalic
                           ? 'bolditalic'
                           : col.isBold
                              ? 'bold'
                              : col.isItalic
                                 ? 'italic'
                                 : 'normal';

                     const cellValue = getCellValue(transaction, col, itemIndex, true);
                     const isSerialColumn =
                        col.id === 'serialNo' || col.id === 'serial_no' || col.id === 'serialNumber';

                     return {
                        content: cellValue,
                        styles: {
                           fontSize: 8,
                           textColor: textColor,
                           fontStyle: fontStyle,
                           halign: col.isNumeric ? 'right' : 'left',
                           cellPadding: isSerialColumn ? 1.5 : 0.5, // Extra padding for serial numbers
                           // Add visual indication for sub-items
                           fillColor: isFirstItem ? null : '#F8FAFC',
                           // Only bottom border
                           lineWidth: { bottom: isLastItem ? 0.3 : 0.1 },
                           lineColor: [200, 200, 200],
                           valign: 'top', // Top alignment for multi-line content
                           overflow: 'linebreak',
                        },
                     };
                  });
                  rows.push(row);
               });
            } else {
               // Single row for single item or when not in multi-item format
               const row = sortedColumns.map((col) => {
                  const textColor = col.color ? convertBackendColor(col.color) : [0, 0, 0];
                  const fontStyle =
                     col.isBold && col.isItalic
                        ? 'bolditalic'
                        : col.isBold
                           ? 'bold'
                           : col.isItalic
                              ? 'italic'
                              : 'normal';

                  const cellValue = getCellValue(transaction, col, 0, false);
                  const isSerialColumn = col.id === 'serialNo' || col.id === 'serial_no' || col.id === 'serialNumber';

                  return {
                     content: cellValue,
                     styles: {
                        fontSize: 8,
                        textColor: textColor,
                        fontStyle: fontStyle,
                        halign: col.isNumeric ? 'right' : 'left',
                        cellPadding: isSerialColumn ? 1.5 : 0.5, // Extra padding for serial numbers
                        // Only bottom border
                        lineWidth: { bottom: 0.2 },
                        lineColor: [200, 200, 200],
                        valign: 'top', // Top alignment for multi-line content
                        overflow: 'linebreak',
                     },
                  };
               });
               rows.push(row);
            }
         });

         return rows;
      };

      // Enhanced header creation with top alignment for multi-line support
      const createDynamicHeader = () => {
         return sortedColumns.map((col) => {
            const textColor = col.color ? convertBackendColor(col.color) : [0, 0, 0];
            const fontStyle =
               col.isBold && col.isItalic ? 'bolditalic' : col.isBold ? 'bold' : col.isItalic ? 'italic' : 'normal';

            return {
               content: col.header || col.id,
               styles: {
                  fontSize: 7,
                  fontStyle: fontStyle,
                  textColor: textColor,
                  halign: col.isNumeric ? 'right' : 'left',
                  cellPadding: 1,
                  // Only bottom border for header
                  lineWidth: { bottom: 0.4 },
                  lineColor: [100, 100, 100],
                  valign: 'top', // Top alignment for headers too
               },
            };
         });
      };

      // Process data
      let data = [];
      const totalCols = sortedColumns.length;

      // Function to add a row with styling
      const addStyledRow = (content, colSpan = 1, styles = {}) => {
         const row = Array(totalCols).fill({ content: '', styles: {} });
         row[0] = {
            content,
            colSpan: Math.min(colSpan, totalCols),
            styles: {
               fillColor: styles.fillColor || null,
               fontStyle: styles.fontStyle || 'normal',
               textColor: styles.textColor || [0, 0, 0],
               fontSize: styles.fontSize || 8,
               cellPadding: styles.cellPadding || 1,
               halign: styles.halign || 'left',
               valign: 'top', // Top alignment for styled rows
               // Add bottom border for styled rows
               lineWidth: { bottom: 0.3 },
               lineColor: [150, 150, 150],
            },
         };
         data.push(row);
      };

      // Function to add transaction rows
      const addTransactionRows = (transactions) => {
         const transactionRows = createPurchaseTransactionRows(transactions, formatType === 'with_item_detail');
         data.push(...transactionRows);
      };

      // Function to calculate totals
      const calculateTotals = (transactions) => {
         const totals = {};
         sortedColumns.forEach((col) => {
            if (col.isNumeric || ['netAmount', 'basicAmount', 'totalQty1', 'billAmount'].includes(col.id)) {
               // Special handling for totalQty1 in with_item_detail format
               if (col.id === 'totalQty1' && formatType === 'with_item_detail') {
                  totals[col.id] = transactions.reduce((sum, trans) => {
                     // For with_item_detail, sum up all item quantities from purchaseLineItems
                     if (trans.purchaseLineItems && Array.isArray(trans.purchaseLineItems)) {
                        const transactionQty = trans.purchaseLineItems.reduce((itemSum, item) => {
                           return itemSum + (Number(item.qty1) || 0);
                        }, 0);
                        return sum + transactionQty;
                     }
                     // Fallback to totalQty1 if purchaseLineItems not available
                     return sum + (Number(trans.totalQty1) || 0);
                  }, 0);
               } else if (col.id === 'lineNetAmount' && formatType === 'with_item_detail') {
                  // For lineNetAmount, sum up all item amounts from purchaseLineItems
                  totals[col.id] = transactions.reduce((sum, trans) => {
                     if (trans.purchaseLineItems && Array.isArray(trans.purchaseLineItems)) {
                        const transactionAmt = trans.purchaseLineItems.reduce((itemSum, item) => {
                           return itemSum + (Number(item.netAmt) || 0);
                        }, 0);
                        return sum + transactionAmt;
                     }
                     return sum;
                  }, 0);
               } else {
                  // Default calculation for other columns
                  totals[col.id] = transactions.reduce((sum, trans) => {
                     const val = getCellValue(trans, col);
                     const numVal = Number(String(val).replace(/[₹,]/g, '')) || 0;
                     return sum + numVal;
                  }, 0);
               }
            }
         });
         return totals;
      };

      // MAIN PROCESSING LOGIC
      salesReport.forEach((companyData) => {
         const companyName = companyData.companyName;
         let allTransactions = [];

         // Extract transactions based on report type
         if (isDynamicFormat) {
            // For dynamic formats, use the flattened data
            allTransactions = companyData.data || [];
         } else {
            // For static formats, we need to extract from nested structure
            if (reportType === REPORT_TYPE.party || reportType === 'party') {
               // Extract from party-wise structure
               companyData.data?.forEach((accountData) => {
                  if (accountData.data) {
                     allTransactions = allTransactions.concat(accountData.data);
                  }
               });
            } else {
               // Extract from date-wise structure
               companyData.data?.forEach((dateData) => {
                  if (dateData.data) {
                     allTransactions = allTransactions.concat(dateData.data);
                  }
               });
            }
         }

         // Calculate company totals
         const companyTotals = calculateTotals(allTransactions);
         const qtyCol = sortedColumns.find(
            (col) => col.id === 'totalQty1' || col.id === 'qty' || col.header?.toLowerCase().includes('qty'),
         );
         const amountCol = sortedColumns.find(
            (col) =>
               ['netAmount', 'billAmount', 'basicAmount'].includes(col.id) ||
               col.header?.toLowerCase().includes('amount'),
         );

         const totalQty = qtyCol ? companyTotals[qtyCol.id] || 0 : 0;
         const totalAmount = amountCol ? companyTotals[amountCol.id] || 0 : 0;

         // Add company header with both Qty and Amt in the same row
         addStyledRow(
            `${companyName} (${allTransactions.length
            } transactions) Qty: ${totalQty.toLocaleString()} Amt: ${totalAmount.toLocaleString()}`,
            totalCols,
            {
               fillColor: '#F1F0E8',
               fontStyle: 'bold',
               fontSize: 9,
               cellPadding: 2,
            },
         );

         // Process based on format type
         if (isDynamicFormat) {
            if (formatDefName === 'PurchaseDetailParty') {
               // Group by party for dynamic party format
               const groupedByParty = {};
               allTransactions.forEach((trans) => {
                  const party = trans.accountname || trans.partyName || trans.party_name || 'Unknown Party';
                  if (!groupedByParty[party]) groupedByParty[party] = [];
                  groupedByParty[party].push(trans);
               });

               Object.entries(groupedByParty).forEach(([partyName, partyTrans]) => {
                  const partyTotals = calculateTotals(partyTrans);
                  const partyQty = qtyCol ? partyTotals[qtyCol.id] || 0 : 0;
                  const partyAmount = amountCol ? partyTotals[amountCol.id] || 0 : 0;

                  // Add party header
                  addStyledRow(
                     `${partyName} Qty: ${partyQty.toLocaleString()} Amt: ${partyAmount.toLocaleString()}`,
                     totalCols,
                     {
                        fillColor: '#F5EEE6',
                        fontStyle: 'bold',
                        fontSize: 8,
                        cellPadding: 1,
                     },
                  );

                  // Add transactions with multi-item support
                  addTransactionRows(partyTrans);
               });
            } else if (formatDefName === 'PurchaseDetailDate') {
               // Group by date for dynamic date format
               const groupedByDate = {};
               allTransactions.forEach((trans) => {
                  const date =
                     formatDateStrict(trans.transactionAt || trans.date || trans.transaction_date) || 'No Date';
                  if (!groupedByDate[date]) groupedByDate[date] = [];
                  groupedByDate[date].push(trans);
               });

               Object.entries(groupedByDate).forEach(([date, dateTrans]) => {
                  const dateTotals = calculateTotals(dateTrans);
                  const dateQty = qtyCol ? dateTotals[qtyCol.id] || 0 : 0;
                  const dateAmount = amountCol ? dateTotals[amountCol.id] || 0 : 0;

                  // Add date header
                  addStyledRow(
                     `${date} Qty: ${dateQty.toLocaleString()} Amt: ${dateAmount.toLocaleString()}`,
                     totalCols,
                     {
                        fillColor: '#E5E5E5',
                        fontStyle: 'bold',
                        fontSize: 8,
                        cellPadding: 1,
                     },
                  );

                  // Add transactions with multi-item support
                  addTransactionRows(dateTrans);
               });
            } else {
               // Default dynamic format - add all transactions directly with multi-item support
               addTransactionRows(allTransactions);
            }
         } else {
            // Static format processing with multi-item support
            if (reportType === REPORT_TYPE.party || reportType === 'party') {
               // Static party format
               if (companyData.data) {
                  companyData.data.forEach((accountData) => {
                     const accountTransactions = accountData.data || [];
                     const accountTotals = calculateTotals(accountTransactions);
                     const accountQty = qtyCol ? accountTotals[qtyCol.id] || 0 : 0;
                     const accountAmount = amountCol ? accountTotals[amountCol.id] || 0 : 0;

                     // Add account header
                     addStyledRow(
                        `${accountData.accountName
                        } Qty: ${accountQty.toLocaleString()} Amt: ${accountAmount.toLocaleString()}`,
                        totalCols,
                        {
                           fillColor: '#F5EEE6',
                           fontStyle: 'bold',
                           fontSize: 8,
                           cellPadding: 1,
                        },
                     );

                     // Add transactions with multi-item support
                     addTransactionRows(accountTransactions);
                  });
               }
            } else {
               // Static date format with multi-item support
               const itemData = companyData.data?.flatMap((item) => item.data || []) || [];

               // Group by date
               const groupedByDate = {};
               itemData.forEach((trans) => {
                  const date = formatDateStrict(trans.transactionAt) || 'No Date';
                  if (!groupedByDate[date]) groupedByDate[date] = [];
                  groupedByDate[date].push(trans);
               });

               Object.entries(groupedByDate).forEach(([date, dateTransactions]) => {
                  const dateTotals = calculateTotals(dateTransactions);
                  const dateQty = qtyCol ? dateTotals[qtyCol.id] || 0 : 0;
                  const dateAmount = amountCol ? dateTotals[amountCol.id] || 0 : 0;

                  // Add date header
                  addStyledRow(
                     `${date} Qty: ${dateQty.toLocaleString()} Amt: ${dateAmount.toLocaleString()}`,
                     totalCols,
                     {
                        fillColor: '#E5E5E5',
                        fontStyle: 'bold',
                        fontSize: 8,
                        cellPadding: 1,
                     },
                  );

                  // Add transactions with multi-item support
                  addTransactionRows(dateTransactions);
               });
            }
         }

         // Add spacing after company with subtle bottom border
         data.push(
            Array(totalCols).fill({
               content: '',
               styles: {
                  cellPadding: 2,
                  lineWidth: { bottom: 0.3 },
                  lineColor: [220, 220, 220],
               },
            }),
         );
      });

      // Generate table
      if (data.length === 0) {
         alert('No data found to generate PDF');
         return;
      }

      doc.autoTable({
         head: [createDynamicHeader()],
         body: data,
         startY: 25,
         margin: { left: 10, right: 10 },
         styles: {
            fontSize: 8,
            cellPadding: 1,
            overflow: 'linebreak',
            lineWidth: 0, // No borders by default
            valign: 'top', // Top alignment for all cells to support multi-line content
         },
         headStyles: {
            fillColor: [220, 220, 220],
            textColor: [0, 0, 0],
            fontStyle: 'bold',
            halign: 'center',
            fontSize: 7,
            lineWidth: { bottom: 0.4 }, // Only bottom border for header
            lineColor: [100, 100, 100],
            valign: 'top', // Top alignment for header
         },
         bodyStyles: {
            lineWidth: 0, // No borders for body
            valign: 'top', // Top alignment for body cells
         },
         alternateRowStyles: {
            fillColor: '#F8FAFC',
            lineWidth: 0, // No borders
            valign: 'top', // Top alignment for alternate rows
         },
         columnStyles: columnStyles,
         tableWidth: 'wrap',
         // Enhanced row height calculation for multi-line content
         didParseCell: function (data) {
            // Increase minimum row height for cells with multi-line content
            if (data.cell.text && typeof data.cell.text === 'string' && data.cell.text.includes('\n')) {
               const lineCount = data.cell.text.split('\n').length;
               data.cell.styles.minCellHeight = Math.max(data.cell.styles.minCellHeight || 0, lineCount * 4);
            }
         },
      });

      // Save PDF
      const formatName = isDynamicFormat
         ? dynamicOptions?.find((opt) => opt.value === reportType)?.label || reportType
         : staticReportTypeOptions?.find((opt) => opt.value === reportType)?.label || reportType;

      doc.save(`${formatName}_Report_${moment().format('YYYYMMDD_HHmmss')}.pdf`);
   }, [
      salesReport,
      dateRange.fromDate,
      dateRange.toDate,
      companyFilter,
      staticReportTypeOptions,
      reportType,
      dynamicValues,
      dynamicOptions,
      getColumnsReportsSalesDetail,
      formatType,
      dynamicColumns,
      companyList,
      columnVisibility,
      isTextile
   ]);

   const renderReportContent = () => {
      if (isLoading) {
         return (
            <Tr>
               <Td colSpan={table.getVisibleFlatColumns().length} textAlign="center" py="100px">
                  <Loader />
               </Td>
            </Tr>
         );
      }

      if (!salesReport || salesReport.length === 0) {
         return (
            <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
               <Td
                  p="2px"
                  py="3px"
                  fontSize="10px"
                  whiteSpace="nowrap"
                  textOverflow="ellipsis"
                  maxW="150px"
                  overflow="hidden"
                  colSpan={table.getVisibleFlatColumns().length}
                  justifyContent="center"
                  alignItems="center"
                  width="100%">
                  <Grid justifyContent="center" alignItems="center" gap={9}>
                     <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                     <GridItem justifySelf="center">
                        <label>No purchase data found</label>
                     </GridItem>
                  </Grid>
               </Td>
            </Tr>
         );
      }

      // Handle custom dynamic report formats
      if (dynamicValues.includes(reportType)) {
         // Find the selected dynamic format
         const selectedFormat = dynamicOptions.find((opt) => opt.value === reportType);
         const viewJson = selectedFormat?.viewJson || [];
         const formatDefName = selectedFormat?.formatData?.defName;

         // Check if it's a supported report type
         const isPurchaseReturnDetailDate =
            formatDefName === 'PurchaseReturnDetailDate' || formatDefName === 'PurchaseReturnDetailBroker';
         const isPurchaseReturnDetailParty = formatDefName === 'PurchaseReturnDetailParty';

         // Only render UI if it's one of the supported types
         if (!isPurchaseReturnDetailDate && !isPurchaseReturnDetailParty) {
            return null;
         }

         // Helper function to convert backend colors
         const convertBackendColor = (backendColor) => {
            if (!backendColor) return null;
            if (backendColor.startsWith('#')) return backendColor;
            if (backendColor.startsWith('0xff')) return '#' + backendColor.substring(4);
            if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) return '#' + backendColor;
            return backendColor;
         };

         // Function to check if column should be visible
         const shouldShowColumn = (columnId) => {
            // First check if column is hidden by report type
            const columnsToHide = [];
            if (reportType === 'date') {
               columnsToHide.push('date');
            } else if (reportType === 'party') {
               columnsToHide.push('party', 'partyName');
            } else if (reportType === 'broker') {
               columnsToHide.push('broker', 'brokerName');
            }

            if (columnsToHide.includes(columnId)) {
               return false;
            }

            // Then check viewJson configuration
            const viewItem = viewJson.find(
               (item) =>
                  item.defName?.toLowerCase() === columnId.toLowerCase() ||
                  item.title?.toLowerCase() === columnId.toLowerCase(),
            );

            // If viewJson has configuration for this column, respect its isShow setting
            if (viewItem) {
               return viewItem.isShow === true || viewItem.isShow === 'true';
            }

            // Default to showing if no configuration exists
            return true;
         };

         // Function to render table headers
         const renderTableHeaders = (bgColor = '#F5F5F5', darkBg = '#080238') => {
            return (
               <Tr>
                  {table.getHeaderGroups().map((headerGroup) => (
                     <React.Fragment key={headerGroup.id}>
                        {headerGroup.headers.map((header) => {
                           if (!shouldShowColumn(header.column.id)) {
                              return null;
                           }

                           const columnDef = dynamicColumns.find((col) => col.id === header.column.id);
                           const viewItem = viewJson.find(
                              (item) =>
                                 item.title?.toLowerCase() === header.column.id.toLowerCase() ||
                                 item.defName?.toLowerCase() === header.column.id.toLowerCase(),
                           );

                           const headerStyles = {
                              color: viewItem?.color ? convertBackendColor(viewItem.color) : textColor,
                              fontWeight: viewItem?.isBold ? 'bold' : 'normal',
                              fontStyle: viewItem?.isItalic ? 'italic' : 'normal',
                           };

                           const isNumericColumn = columnDef?.isNumeric;

                           return (
                              <Th
                                 borderTop="1px solid"
                                 key={header.id}
                                 colSpan={header.colSpan}
                                 borderColor={borderColor}
                                 cursor="pointer"
                                 p="2px"
                                 style={headerStyles}
                                 py="4px"
                                 fontSize="10px"
                                 _dark={{ bg: '#080238' }}
                                 fontWeight="600"
                                 bg={'#F5F5F5'}
                                 position="sticky"
                                 top="-1"
                                 zIndex="1"
                                 color={isDark ? '#FFF' : '#000'}
                                 isNumeric={isNumericColumn}
                                 whiteSpace="nowrap"
                                 onClick={header.column.getToggleSortingHandler()}>
                                 <Flex
                                    justifyContent={isNumericColumn ? 'flex-end' : 'space-between'}
                                    align="center"
                                    fontSize={{ sm: '10px', lg: '12px' }}
                                    color={isDark ? '#FFF' : '#000'}>
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                    {{
                                       asc: '↑',
                                       desc: '↓',
                                    }[header.column.getIsSorted()] ?? null}
                                 </Flex>
                              </Th>
                           );
                        })}
                     </React.Fragment>
                  ))}
               </Tr>
            );
         };

         // RENDER DATE FORMAT
         if (isPurchaseReturnDetailDate) {
            // Create an array to hold all rendered content
            const dateContent = [];

            // Calculate grand totals for the top
            const { grandTotalQty, grandTotalAmt } = calculateGrandTotals();

            // Get visible columns
            const visibleColumns = table.getAllColumns().filter((column) => column.getIsVisible());

            // Count value columns (qty and amount columns)
            const valueColumnsCount = visibleColumns.filter(col =>
               col.id === 'qty' ||
               col.id === 'totalQty1' ||
               col.id.toLowerCase().includes('qty') ||
               ['netAmount', 'billAmount', 'taxableAmount', 'gstAmount'].includes(col.id)
            ).length;

            // Text column should span across all remaining columns
            const textColumnSpan = visibleColumns.length - valueColumnsCount;

            // Add GRAND TOTAL at the TOP (if multiple companies selected)
            if (companyFilter.length > 1) {
               dateContent.push(
                  <Tr
                     key="grand-total-top-date"
                     bg={isDark ? '#1a3a6b' : '#E8E2D9'}
                     fontWeight="bold"
                     borderTop="3px solid"
                     borderBottom="2px solid"
                     borderColor={borderColor}
                     position="sticky"
                     top="0"
                     zIndex="4">
                     {visibleColumns.map((column, colIndex) => {
                        const cellKey = `grand-total-top-date-${column.id}-${colIndex}`;

                        if (colIndex === 0) {
                           return (
                              <Td
                                 key={cellKey}
                                 p="2px"
                                 py="5px"
                                 fontSize="16px"
                                 fontWeight={700}
                                 color={isDark ? '#FFF' : '#000'}
                                 colSpan={textColumnSpan}>
                                 GRAND TOTAL ({companyFilter.length} Companies)
                              </Td>
                           );
                        }

                        if (column.id === 'qty' || column.id === 'totalQty1' || column.id.toLowerCase().includes('qty')) {
                           return (
                              <Td
                                 key={cellKey}
                                 p="2px"
                                 py="5px"
                                 fontSize="16px"
                                 fontWeight={700}
                                 color={isDark ? '#FFF' : '#000'}
                                 isNumeric
                                 textAlign="right">
                                 {grandTotalQty.toLocaleString()}
                              </Td>
                           );
                        }

                        if (column.id === 'netAmount') {
                           return (
                              <Td
                                 key={cellKey}
                                 p="2px"
                                 py="5px"
                                 fontSize="16px"
                                 fontWeight={700}
                                 color={isDark ? '#FFF' : '#000'}
                                 isNumeric
                                 textAlign="right">
                                 ₹{grandTotalAmt.toLocaleString()}
                              </Td>
                           );
                        }

                        if (column.id === 'billAmount') {
                           return (
                              <Td
                                 key={cellKey}
                                 p="2px"
                                 py="5px"
                                 fontSize="16px"
                                 fontWeight={700}
                                 color={isDark ? '#FFF' : '#000'}
                                 isNumeric
                                 textAlign="right">
                                 ₹{grandTotalAmt.toLocaleString()}
                              </Td>
                           );
                        }

                        if (['taxableAmount', 'gstAmount'].includes(column.id)) {
                           return (
                              <Td
                                 key={cellKey}
                                 p="2px"
                                 py="5px"
                                 fontSize="16px"
                                 fontWeight={700}
                                 color={isDark ? '#FFF' : '#000'}
                                 isNumeric
                                 textAlign="right">
                                 ₹{grandTotalAmt.toLocaleString()}
                              </Td>
                           );
                        }

                        return <Td key={cellKey} p="2px" py="5px" />;
                     })}
                  </Tr>
               );
            }

            // Process each company's data
            salesReport.forEach((companyData, companyIndex) => {
               const flattenedData = companyData.data || [];

               // Group items by date
               const groupedByDate = flattenedData.reduce((acc, item) => {
                  const date = item.transactionAt || 'No Date';
                  if (!acc[date]) {
                     acc[date] = [];
                  }
                  acc[date].push(item);
                  return acc;
               }, {});

               // Company Header
               dateContent.push(
                  <Tr key={`company-${companyData.companyId || companyIndex}`} bg="#F1F0E8" _dark={{ bg: 'blue.700' }} fontWeight="bold" color={isDark ? '#FFF' : '#000'} pl={4}>
                     <Td
                        colSpan={visibleColumns.filter((col) => shouldShowColumn(col.id)).length}
                        p="2px"
                        py="3px"
                        fontSize="10px"
                        whiteSpace="nowrap"
                        textOverflow="ellipsis"
                        color={isDark ? '#FFF' : '#000'}>
                        <Flex justifyContent="space-between" alignItems="center">
                           <Text fontWeight="bold" fontSize="lg">
                              {companyData.companyName}
                           </Text>
                           <Flex gap={4}>
                              <Text fontWeight="600" fontSize="15px">
                                 Qty: {flattenedData.reduce((sum, t) => sum + (t?.totalQty1 || 0), 0).toLocaleString()}
                              </Text>
                              <Text fontWeight="bold" fontSize="15px">
                                 Amt: ₹{flattenedData.reduce((sum, t) => sum + (t?.netAmount || 0), 0).toLocaleString()}
                              </Text>
                           </Flex>
                        </Flex>
                     </Td>
                  </Tr>
               );

               // Table Headers
               dateContent.push(renderTableHeaders());

               // Grouped by Date
               Object.entries(groupedByDate).forEach(([date, dateItems]) => (
                  <React.Fragment key={`date-group-${date}`}>
                     {/* Date Header Row */}
                     <Tr bg="gray.100" _dark={{ bg: 'gray.700' }}>
                        <Td
                           colSpan={table.getAllColumns().filter((c) => shouldShowColumn(c.id)).length}
                           p="2px"
                           py="3px"
                           color={isDark ? '#FFF' : '#000'}
                           fontWeight="bold"
                           fontSize="sm">
                           {date}
                        </Td>
                     </Tr>

                     {/* Items for this date */}
                     {renderDataRows(dateItems, table, borderColor, shouldShowColumn, viewJson)}
                  </React.Fragment>
               ));
            });

            return dateContent;
         }

         // RENDER PARTY FORMAT
         if (isPurchaseReturnDetailParty) {
            // Create an array to hold all rendered content
            const partyContent = [];

            // Calculate grand totals for the top
            const { grandTotalQty, grandTotalAmt } = calculateGrandTotals();

            // Get visible columns
            const visibleColumns = table.getAllColumns().filter((column) => column.getIsVisible());

            // Count value columns (qty and amount columns)
            const valueColumnsCount = visibleColumns.filter(col =>
               col.id === 'qty' ||
               col.id === 'totalQty1' ||
               col.id.toLowerCase().includes('qty') ||
               ['netAmount', 'billAmount', 'taxableAmount', 'gstAmount'].includes(col.id)
            ).length;

            // Text column should span across all remaining columns
            const textColumnSpan = visibleColumns.length - valueColumnsCount;

            // Add GRAND TOTAL at the TOP (if multiple companies selected)
            if (companyFilter.length > 1) {
               const grandTotalCells = [];
               grandTotalCells.push(
                  <Td
                     key="grand-total-text"
                     p="2px"
                     py="5px"
                     fontSize="16px"
                     fontWeight={700}
                     color={isDark ? '#FFF' : '#000'}
                     colSpan={visibleColumns.length - 2}>
                     GRAND TOTAL ({companyFilter.length} Companies)
                  </Td>
               );

               // Add Qty column
               grandTotalCells.push(
                  <Td
                     key="grand-total-qty"
                     p="2px"
                     py="5px"
                     fontSize="16px"
                     fontWeight={700}
                     color={isDark ? '#FFF' : '#000'}>
                     Qty : {grandTotalQty.toLocaleString()}
                  </Td>
               );

               // Add Amount column
               grandTotalCells.push(
                  <Td
                     key="grand-total-amt"
                     p="2px"
                     py="5px"
                     fontSize="16px"
                     fontWeight={700}
                     color={isDark ? '#FFF' : '#000'}>
                     Net Amt : ₹{grandTotalAmt.toLocaleString()}
                  </Td>
               );

               dateDefaultContent.push(
                  <Tr
                     key="grand-total-top-default"
                     bg={isDark ? '#1a3a6b' : '#E8E2D9'}
                     fontWeight="bold"
                     borderTop="3px solid"
                     borderBottom="2px solid"
                     borderColor={borderColor}
                     position="sticky"
                     top="0"
                     zIndex="4">
                     {grandTotalCells}
                  </Tr>
               );
            }

            // Process each company's data
            salesReport.forEach((companyData, companyIndex) => {
               const flattenedData = companyData.data || [];

               // Group the flattened data by party (accountName)
               const groupedByParty = flattenedData.reduce((acc, transaction) => {
                  const partyName = transaction.accountName || transaction.accountname || 'Unknown Party';

                  if (!acc[partyName]) {
                     acc[partyName] = {
                        accountName: partyName,
                        transactions: [],
                        totalQty: 0,
                        totalAmount: 0,
                     };
                  }

                  acc[partyName].transactions.push(transaction);
                  acc[partyName].totalQty += transaction.totalQty1 || 0;
                  acc[partyName].totalAmount += transaction.netAmount || 0;

                  return acc;
               }, {});

               // Convert grouped object to array
               const partyGroups = Object.values(groupedByParty);

               // Company Header
               partyContent.push(
                  <Tr key={`company-${companyData.companyId || companyIndex}`} bg="#F1F0E8" _dark={{ bg: 'blue.700' }} fontWeight="bold" color={isDark ? '#FFF' : '#000'} pl={4}>
                     <Td
                        colSpan={visibleColumns.filter((col) => shouldShowColumn(col.id)).length}
                        p="2px"
                        py="3px"
                        fontSize="10px"
                        whiteSpace="nowrap"
                        textOverflow="ellipsis"
                        color={isDark ? '#FFF' : '#000'}>
                        <Flex justifyContent="space-between" alignItems="center">
                           <Text fontWeight="bold" fontSize="lg">
                              {companyData.companyName}
                           </Text>
                           <Flex gap={4}>
                              <Text fontWeight="600" fontSize="15px">
                                 Qty: {flattenedData.reduce((sum, t) => sum + (t?.totalQty1 || 0), 0).toLocaleString()}
                              </Text>
                              <Text fontWeight="bold" fontSize="15px">
                                 Amt: ₹{flattenedData.reduce((sum, t) => sum + (t?.netAmount || 0), 0).toLocaleString()}
                              </Text>
                           </Flex>
                        </Flex>
                     </Td>
                  </Tr>
               );

               // Render each party group
               partyGroups.forEach((partyGroup, partyIndex) => {
                  // Party Header Row
                  partyContent.push(
                     <Tr
                        key={`party-${companyIndex}-${partyIndex}`}
                        bg="#F5EEE6"
                        _dark={{ bg: 'blue.900' }}
                        cursor="pointer"
                        borderBottom={'1px solid'}
                        borderColor={borderColor}
                        onClick={() => toggleExpand(`party-${companyIndex}-${partyIndex}`)}>
                        <Td
                           colSpan={visibleColumns.filter((col) => shouldShowColumn(col.id)).length - 2}
                           p="4px"
                           fontSize={'14px'}
                           fontWeight="bold"
                           color={isDark ? '#FFF' : '#000'}>
                           <Flex alignItems="center" gap={2}>
                              <Text>{partyGroup.accountName}</Text>
                           </Flex>
                        </Td>
                        <Td p="4px" fontSize="14px" fontWeight="bold" color={isDark ? '#FFF' : '#000'} textAlign="right">
                           Qty: {partyGroup.totalQty.toLocaleString()}
                        </Td>
                        <Td p="4px" fontSize="14px" fontWeight="bold" color={isDark ? '#FFF' : '#000'} textAlign="right">
                           Amt: ₹{partyGroup.totalAmount.toLocaleString()}
                        </Td>
                     </Tr>
                  );

                  // Show party transactions - Always expanded by default
                  if (expandedItems[`party-${companyIndex}-${partyIndex}`] !== false) {
                     // Table Headers for this party
                     partyContent.push(renderTableHeaders());

                     // Party Transaction Rows
                     partyContent.push(
                        renderDataRows(partyGroup.transactions, table, borderColor, shouldShowColumn, viewJson)
                     );
                  }
               });
            });

            return partyContent;
         }

         return null;
      }

      // Handle party report type with full hierarchical structure
      if (reportType === REPORT_TYPE.party) {
         // Create an array to hold all rendered content
         const partyHierarchyContent = [];

         // Calculate grand totals for the top
         const { grandTotalQty, grandTotalAmt } = calculateGrandTotals();

         // Get visible columns
         const visibleColumns = table.getAllColumns().filter((column) => column.getIsVisible());

         // Count value columns (qty and amount columns)
         const valueColumnsCount = visibleColumns.filter(col =>
            col.id === 'qty' ||
            col.id === 'totalQty1' ||
            col.id.toLowerCase().includes('qty') ||
            ['netAmount', 'billAmount', 'taxableAmount', 'gstAmount'].includes(col.id)
         ).length;

         // Text column should span across all remaining columns
         const textColumnSpan = visibleColumns.length - valueColumnsCount;

         // Add GRAND TOTAL at the TOP (if multiple companies selected)
         if (companyFilter.length > 1) {
            const grandTotalCells = [];
            grandTotalCells.push(
               <Td
                  key="grand-total-text"
                  p="2px"
                  py="5px"
                  fontSize="16px"
                  fontWeight={700}
                  color={isDark ? '#FFF' : '#000'}
                  colSpan={visibleColumns.length - 2}>
                  GRAND TOTAL ({companyFilter.length} Companies)
               </Td>
            );

            // Add Qty column
            grandTotalCells.push(
               <Td
                  key="grand-total-qty"
                  p="2px"
                  py="5px"
                  fontSize="16px"
                  fontWeight={700}
                  color={isDark ? '#FFF' : '#000'}>
                  Qty : {grandTotalQty.toLocaleString()}
               </Td>
            );

            // Add Amount column
            grandTotalCells.push(
               <Td
                  key="grand-total-amt"
                  p="2px"
                  py="5px"
                  fontSize="16px"
                  fontWeight={700}
                  color={isDark ? '#FFF' : '#000'}>
                  Net Amt : ₹{grandTotalAmt.toLocaleString()}
               </Td>
            );

            dateDefaultContent.push(
               <Tr
                  key="grand-total-top-default"
                  bg={isDark ? '#1a3a6b' : '#E8E2D9'}
                  fontWeight="bold"
                  borderTop="3px solid"
                  borderBottom="2px solid"
                  borderColor={borderColor}
                  position="sticky"
                  top="0"
                  zIndex="4">
                  {grandTotalCells}
               </Tr>
            );
         }

         // Process each company's data
         salesReport.forEach((companyData, companyIndex) => {
            // Company Level
            partyHierarchyContent.push(
               <Tr
                  key={`company-${companyData.companyId || companyIndex}`}
                  bg="#F1F0E8"
                  _dark={{ bg: 'purple.900' }}
                  cursor="pointer"
                  onClick={() => toggleExpand(`company-${companyData.companyId}`)}>
                  <Td
                     p="2px"
                     py="3px"
                     fontSize="10px"
                     whiteSpace="nowrap"
                     textOverflow="ellipsis"
                     maxW="150px"
                     color={isDark ? '#FFF' : '#000'}
                     overflow="hidden"
                     colSpan={visibleColumns.length - 2}>
                     <Flex justifyContent="space-between" alignItems="center">
                        <Text fontWeight="bold" fontSize="lg">
                           {companyData.companyName}
                        </Text>
                     </Flex>
                  </Td>
                  <Td
                     p="2px"
                     py="3px"
                     color={isDark ? '#FFF' : '#000'}
                     whiteSpace="nowrap"
                     textOverflow="ellipsis"
                     maxW="150px"
                     overflow="hidden">
                     <Flex alignItems={'center'}>
                        <Text fontWeight="600" fontSize={'15px'} color={isDark ? '#FFF' : '#000'}>
                           {companyData.data
                              .reduce((sum, account) => sum + (account.totalQty1 || 0), 0)
                              .toLocaleString()}
                        </Text>
                     </Flex>
                  </Td>
                  <Td
                     p="2px"
                     py="3px"
                     color={isDark ? '#FFF' : '#000'}
                     whiteSpace="nowrap"
                     textOverflow="ellipsis"
                     maxW="150px"
                     overflow="hidden">
                     <Flex justifyContent="end" alignItems={'center'}>
                        <Text fontWeight="600" p={2} fontSize={'15px'} color={isDark ? '#FFF' : '#000'} mr={4}>
                           Amt:
                        </Text>
                        <Text fontWeight="bold" fontSize={'15px'} color={isDark ? '#FFF' : '#000'} mr={4}>
                           ₹
                           {companyData.data
                              .reduce((sum, account) => sum + (account.totalNetAmt || 0), 0)
                              .toLocaleString()}
                        </Text>
                        {expandedItems[`company-${companyData.companyId}`] ? <ChevronUpIcon /> : <ChevronDownIcon />}
                     </Flex>
                  </Td>
               </Tr>
            );

            // Show accounts if company is expanded
            if (expandedItems[`company-${companyData.companyId}`] &&
               companyData.data &&
               Array.isArray(companyData.data)) {
               companyData.data.forEach((accountData, accountIndex) => {
                  // Account/Party Level
                  partyHierarchyContent.push(
                     <Tr
                        key={`party-${accountData.accountId || accountIndex}`}
                        bg="#F5EEE6"
                        _dark={{ bg: 'blue.900' }}
                        cursor="pointer"
                        borderBottom={'1px solid'}
                        borderColor={borderColor}
                        pl={4}
                        onClick={() => toggleExpand(`account-${accountData.accountId}`)}>
                        <Td
                           p="2px"
                           py="3px"
                           fontSize={'14px'}
                           whiteSpace="nowrap"
                           textOverflow="ellipsis"
                           maxW="150px"
                           color={isDark ? '#FFF' : '#000'}
                           overflow="hidden"
                           colSpan={visibleColumns.length - 2}>
                           <Flex justifyContent="space-between" alignItems="center" pl={4}>
                              <Text fontWeight="bold">{accountData.accountName}</Text>
                           </Flex>
                        </Td>
                        <Td
                           p="2px"
                           py="3px"
                           fontSize="15px"
                           fontWeight={600}
                           whiteSpace="nowrap"
                           color={isDark ? '#FFF' : '#000'}
                           textOverflow="ellipsis"
                           maxW="150px"
                           overflow="hidden">
                           <Flex gap={5}>
                              <Text fontWeight="600" fontSize="15px">
                                 Qty: {accountData.totalQty1.toLocaleString()}
                              </Text>
                           </Flex>
                        </Td>
                        <Td
                           p="2px"
                           py="3px"
                           fontSize="15px"
                           fontWeight={600}
                           whiteSpace="nowrap"
                           color={isDark ? '#FFF' : '#000'}
                           textOverflow="ellipsis"
                           maxW="150px"
                           overflow="hidden"
                           isNumeric>
                           <Flex gap={5} justifyContent="end">
                              <Text fontWeight="600" fontSize="15px">
                                 Amt: ₹{accountData.totalNetAmt.toLocaleString()}
                              </Text>
                              <Flex>
                                 {expandedItems[`account-${accountData.accountId}`] ? (
                                    <ChevronUpIcon />
                                 ) : (
                                    <ChevronDownIcon />
                                 )}
                              </Flex>
                           </Flex>
                        </Td>
                     </Tr>
                  );

                  // Transaction Data
                  if (expandedItems[`account-${accountData.accountId}`] &&
                     accountData.data &&
                     Array.isArray(accountData.data)) {
                     partyHierarchyContent.push(renderDataRows(accountData.data));
                  }
               });
            }
         });

         return partyHierarchyContent;
      }

      // Default for date report type
      // Create an array to hold all rendered content
      const dateDefaultContent = [];

      // Calculate grand totals for the top
      const { grandTotalQty, grandTotalAmt } = calculateGrandTotals();

      // Get visible columns
      const visibleColumns = table.getAllColumns().filter((column) => column.getIsVisible());

      // Count value columns (qty and amount columns)
      const valueColumnsCount = visibleColumns.filter(col =>
         col.id === 'qty' ||
         col.id === 'totalQty1' ||
         col.id.toLowerCase().includes('qty') ||
         ['netAmount', 'billAmount', 'taxableAmount', 'gstAmount'].includes(col.id)
      ).length;

      if (companyFilter.length > 1) {
         const grandTotalCells = [];
         grandTotalCells.push(
            <Td
               key="grand-total-text"
               p="2px"
               py="5px"
               fontSize="16px"
               fontWeight={700}
               color={isDark ? '#FFF' : '#000'}
               colSpan={visibleColumns.length - 2}>
               GRAND TOTAL ({companyFilter.length} Companies)
            </Td>
         );

         // Add Qty column
         grandTotalCells.push(
            <Td
               key="grand-total-qty"
               p="2px"
               py="5px"
               fontSize="16px"
               fontWeight={700}
               color={isDark ? '#FFF' : '#000'}>
               Qty : {grandTotalQty.toLocaleString()}
            </Td>
         );

         // Add Amount column
         grandTotalCells.push(
            <Td
               key="grand-total-amt"
               p="2px"
               py="5px"
               fontSize="16px"
               fontWeight={700}
               color={isDark ? '#FFF' : '#000'}>
               Net Amt : ₹{grandTotalAmt.toLocaleString()}
            </Td>
         );

         dateDefaultContent.push(
            <Tr
               key="grand-total-top-default"
               bg={isDark ? '#1a3a6b' : '#E8E2D9'}
               fontWeight="bold"
               borderTop="3px solid"
               borderBottom="2px solid"
               borderColor={borderColor}
               position="sticky"
               top="0"
               zIndex="4">
               {grandTotalCells}
            </Tr>
         );
      }

      // Process each company's data
      salesReport.forEach((dateItem, index) => {
         const itemData = dateItem.data?.flatMap((item) => item.data || []) || [];

         // Group items by date
         const groupedByDate = itemData.reduce((acc, item) => {
            const date = item.transactionAt || 'No Date';
            if (!acc[date]) {
               acc[date] = [];
            }
            acc[date].push(item);
            return acc;
         }, {});

         // Calculate company grand totals
         const companyTotals = {
            qty: itemData.reduce((sum, t) => {
               // Try different qty field names
               const val = Number(t.qty || t.totalQty1 || t.quantity || 0);
               return sum + (isNaN(val) ? 0 : val);
            }, 0),
            netAmount: itemData.reduce((sum, t) => sum + (Number(t.netAmount) || 0), 0),
            billAmount: itemData.reduce((sum, t) => sum + (Number(t.netAmount) || 0), 0),
            taxableAmount: itemData.reduce((sum, t) => sum + (Number(t.taxableAmount) || 0), 0),
            gstAmount: itemData.reduce((sum, t) => sum + (Number(t.gstAmount) || 0), 0),
         };

         // Company Header Row with Grand Total
         dateDefaultContent.push(
            <Tr key={`date-${dateItem.date || index}`} bg="#F1F0E8" _dark={{ bg: 'blue.700' }} fontWeight="bold" color={isDark ? '#FFF' : '#000'} pl={4}>
               {visibleColumns.map((column, colIndex) => {
                  const cellKey = `company-header-${column.id}-${colIndex}`;

                  if (colIndex === 0) {
                     return (
                        <Td
                           key={cellKey}
                           p="2px"
                           py="3px"
                           fontSize="10px"
                           whiteSpace="nowrap"
                           textOverflow="ellipsis"
                           maxW="150px"
                           color={isDark ? '#FFF' : '#000'}
                           overflow="hidden">
                           <Flex justifyContent="space-between" alignItems="center">
                              <Text fontWeight="bold" fontSize="lg">
                                 {dateItem.companyName}
                              </Text>
                           </Flex>
                        </Td>
                     );
                  }

                  // Add grand totals to company row
                  if (column.id === 'qty' || column.id === 'totalQty1' || column.id.toLowerCase().includes('qty')) {
                     return (
                        <Td
                           key={cellKey}
                           p="2px"
                           py="3px"
                           fontSize="12px"
                           fontWeight={700}
                           color={isDark ? '#FFF' : '#000'}
                           isNumeric
                           textAlign="right">
                           {companyTotals.qty}
                        </Td>
                     );
                  }

                  if (column.id === 'netAmount') {
                     return (
                        <Td
                           key={cellKey}
                           p="2px"
                           py="3px"
                           fontSize="12px"
                           fontWeight={700}
                           color={isDark ? '#FFF' : '#000'}
                           isNumeric
                           textAlign="right">
                           ₹{companyTotals.netAmount.toLocaleString()}
                        </Td>
                     );
                  }

                  if (column.id === 'billAmount') {
                     return (
                        <Td
                           key={cellKey}
                           p="2px"
                           py="3px"
                           fontSize="12px"
                           fontWeight={700}
                           color={isDark ? '#FFF' : '#000'}
                           isNumeric
                           textAlign="right">
                           ₹{companyTotals.billAmount.toLocaleString()}
                        </Td>
                     );
                  }

                  if (['taxableAmount', 'gstAmount'].includes(column.id)) {
                     return (
                        <Td
                           key={cellKey}
                           p="2px"
                           py="3px"
                           fontSize="12px"
                           fontWeight={700}
                           color={isDark ? '#FFF' : '#000'}
                           isNumeric
                           textAlign="right">
                           ₹{companyTotals[column.id].toLocaleString()}
                        </Td>
                     );
                  }

                  return <Td key={cellKey} p="2px" py="3px" color={isDark ? '#FFF' : '#000'} />;
               })}
            </Tr>
         );

         // Table Headers
         dateDefaultContent.push(
            table.getHeaderGroups().map((headerGroup) => (
               <Tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                     if (!header.column.getIsVisible()) return null;

                     const columnId = header.column.id;
                     const isNumericColumn = [
                        'netAmount',
                        'billAmount',
                        'dueDays',
                        'totalQty1',
                        'itemRate',
                        'returnadjamount',
                        'otheradjamount',
                        'balanceamount',
                        'recDate',
                        'recBook',
                     ].includes(columnId);

                     return (
                        <Th
                           borderTop="1px solid"
                           key={header.id}
                           colSpan={header.colSpan}
                           borderColor={borderColor}
                           cursor="pointer"
                           p="2px"
                           py="4px"
                           fontSize="10px"
                           _dark={{ bg: '#080238' }}
                           fontWeight="600"
                           bg={'#F5F5F5'}
                           position="sticky"
                           top="-1"
                           zIndex="1"
                           color={isDark ? '#FFF' : '#000'}
                           isNumeric={isNumericColumn}
                           whiteSpace="nowrap"
                           onClick={header.column.getToggleSortingHandler()}>
                           <Flex
                              justifyContent={isNumericColumn ? 'flex-end' : 'space-between'}
                              align="center"
                              fontSize={{ sm: '10px', lg: '12px' }}
                              color={isDark ? '#FFF' : '#000'}>
                              {flexRender(header.column.columnDef.header, header.getContext())}
                              {{
                                 asc: '↑',
                                 desc: '↓',
                              }[header.column.getIsSorted()] ?? null}
                           </Flex>
                        </Th>
                     );
                  })}
               </Tr>
            ))
         );

         // Grouped by Date
         Object.entries(groupedByDate).forEach(([date, dateItems]) => {
            // Calculate date-wise totals
            const dateTotals = {
               qty: dateItems.reduce((sum, t) => {
                  // Try different qty field names
                  const val = Number(t.qty || t.totalQty1 || t.quantity || 0);
                  return sum + (isNaN(val) ? 0 : val);
               }, 0),
               netAmount: dateItems.reduce((sum, t) => sum + (Number(t.netAmount) || 0), 0),
               billAmount: dateItems.reduce((sum, t) => sum + (Number(t.netAmount) || 0), 0),
               taxableAmount: dateItems.reduce((sum, t) => sum + (Number(t.taxableAmount) || 0), 0),
               gstAmount: dateItems.reduce((sum, t) => sum + (Number(t.gstAmount) || 0), 0),
            };

            // Date Header Row with Date-wise Totals
            dateDefaultContent.push(
               <Tr key={`date-group-${date}`} bg="gray.100" _dark={{ bg: 'gray.700' }}>
                  {visibleColumns.map((column, colIndex) => {
                     const cellKey = `date-header-${column.id}-${colIndex}`;

                     if (colIndex === 0) {
                        return (
                           <Td
                              key={cellKey}
                              p="2px"
                              py="3px"
                              color={isDark ? '#FFF' : '#000'}
                              fontWeight="bold"
                              fontSize="sm">
                              {date}
                           </Td>
                        );
                     }

                     // Add date-wise totals
                     if (column.id === 'qty' || column.id === 'totalQty1' || column.id.toLowerCase().includes('qty')) {
                        return (
                           <Td
                              key={cellKey}
                              p="2px"
                              py="3px"
                              color={isDark ? '#FFF' : '#000'}
                              fontWeight="bold"
                              fontSize="sm"
                              isNumeric
                              textAlign="right">
                              {dateTotals.qty}
                           </Td>
                        );
                     }

                     if (column.id === 'netAmount') {
                        return (
                           <Td
                              key={cellKey}
                              p="2px"
                              py="3px"
                              color={isDark ? '#FFF' : '#000'}
                              fontWeight="bold"
                              fontSize="sm"
                              isNumeric
                              textAlign="right">
                              ₹{dateTotals.netAmount.toLocaleString()}
                           </Td>
                        );
                     }

                     if (column.id === 'billAmount') {
                        return (
                           <Td
                              key={cellKey}
                              p="2px"
                              py="3px"
                              color={isDark ? '#FFF' : '#000'}
                              fontWeight="bold"
                              fontSize="sm"
                              isNumeric
                              textAlign="right">
                              ₹{dateTotals.billAmount.toLocaleString()}
                           </Td>
                        );
                     }

                     if (['taxableAmount', 'gstAmount'].includes(column.id)) {
                        return (
                           <Td
                              key={cellKey}
                              p="2px"
                              py="3px"
                              color={isDark ? '#FFF' : '#000'}
                              fontWeight="bold"
                              fontSize="sm"
                              isNumeric
                              textAlign="right">
                              ₹{dateTotals[column.id].toLocaleString()}
                           </Td>
                        );
                     }

                     return <Td key={cellKey} p="2px" py="3px" />;
                  })}
               </Tr>
            );

            // Items for this date
            dateDefaultContent.push(renderDataRows(dateItems, table, borderColor));
         });
      });

      return dateDefaultContent;
   };

   const deletePurchaseReturn = () => {
      const selectedDaybook = daybookData.find((db) => db.id === viewDetail?.daybookId);
      console.log('viewDetail data', viewDetail, selectedDaybook);
      if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
         setDataId({ id: viewDetail?.id, daybookId: viewDetail.daybookId, accountId: viewDetail.accountId });
         setIsModalOpen(true);
         setIsOpenPurchaseReturnSingleView(false);
      } else {
         deleteRecord(
            viewDetail?.id,
            deletePurchaseReturnInvoice,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
         );
         setIsOpenPurchaseReturnSingleView(false);
      }
      // deleteRecord(
      //    viewDetail?.id,
      //    deletePurchaseInvoice,
      //    dispatch,
      //    user?.loginhistory?.companyId,
      //    userGlobalSettingsData,
      // );
      // setIsOpenPurchaseReturnSingleView(false);
   };

   const handleSalesDetailsClose = () => {
      setIsOpenPurchaseReturnSingleView();
   };

   // Enhanced renderDataRows function to handle party report format with multi-level item details
   const renderDataRows = (itemData, isPartyReport = false, nestingLevel = 0) => {
      if (!itemData || !Array.isArray(itemData)) return null;

      const paddingLeft = isPartyReport ? `${(nestingLevel + 1) * 20}px` : '4px';

      const handledata = async (data) => {
         const storedCompanyId = localStorage.getItem('companyId');
         const companyId = parseInt(storedCompanyId);
         if (data.companyId === companyId && (admin || rights?.purchasereturn?.view)) {
            await dispatch(
               getSinglePurchaseReturnWithPrevAndNext({
                  id: data.id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
      };

      const formatCurrencyWithSmallDecimals = (value) => {
         if (value == null || value === '') return '₹0';
         const numValue = Number(value);
         if (isNaN(numValue)) return '₹0';

         const formatted = numValue.toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
         });

         const parts = formatted.toString().split('.');

         if (parts.length === 2) {
            return (
               <>
                  ₹{parts[0]}.<span style={{ fontSize: '0.7em' }}>{parts[1]}</span>
               </>
            );
         }

         return `₹${formatted}`;
      };

      return (
         <>
            {/* Header row - shown once per expanded section for party reports */}
            {reportType === REPORT_TYPE.party && !isPartyReport && (
               <Tr bg="#F5F5F5" _dark={{ bg: 'gray.700' }} pl={4}>
                  {table
                     .getAllColumns()
                     .filter((column) => column.getIsVisible())
                     .map((column) => (
                        <Th
                           key={column.id}
                           borderColor={borderColor}
                           p="2px"
                           py="4px"
                           fontWeight="600"
                           color={isDark ? '#FFF' : '#000'}
                           whiteSpace="nowrap"
                           fontSize={{ sm: '10px', lg: '12px' }}>
                           {dynamicColumns.find((c) => c.id === column.id)?.header || column.id}
                        </Th>
                     ))}
               </Tr>
            )}

            {/* Data rows */}
            {itemData.map((transaction, rowIndex) => {
               const isOddRow = rowIndex % 2 !== 0;
               const hasMultipleItems =
                  transaction.purchaseLineItems &&
                  Array.isArray(transaction.purchaseLineItems) &&
                  transaction.purchaseLineItems.length > 1;

               return (
                  <React.Fragment key={`row-${transaction.id || rowIndex}`}>
                     {/* Main transaction row */}
                     <Tr
                        className="editable-row"
                        cursor={'pointer'}
                        onClick={() => handledata(transaction)}
                        bg={isDark
                           ? (isOddRow ? 'rgba(2, 14, 56, 0.7)' : 'transparent')
                           : (isOddRow ? 'rgba(0, 63, 140, 0.05)' : 'transparent')
                        }
                        _hover={{ bg: 'rgba(0, 63, 140, 0.08)' }}
                        style={{ paddingLeft: paddingLeft }}>
                        {table
                           .getAllColumns()
                           .filter((column) => column.getIsVisible())
                           .sort((a, b) => {
                              // Find the column definitions
                              const colA = dynamicColumns.find((col) => col.id === a.id);
                              const colB = dynamicColumns.find((col) => col.id === b.id);
                              // Convert orderNo to numbers for proper sorting
                              const orderA = parseInt(colA?.orderNo) || 0;
                              const orderB = parseInt(colB?.orderNo) || 0;
                              return orderA - orderB;
                           })
                           .map((column, cellIndex) => {
                              const columnDef = dynamicColumns.find((col) => col.id === column.id);
                              const cellStyles = {
                                 color: columnDef?.color || textColor,
                                 fontWeight: columnDef?.isBold ? 'bold' : 'normal',
                                 fontStyle: columnDef?.isItalic ? 'italic' : 'normal',
                                 width: columnWidths[cellIndex],
                              };
                              const cellKey = `${transaction.id}-${column.id}-${cellIndex}`;

                              // Handle transactionAt (Date) column
                              if (column.id === 'transactionAt') {
                                 return (
                                    <Td
                                       borderColor={borderColor}
                                       key={cellKey}
                                       p="2px"
                                       py="3px"
                                       fontSize="13px"
                                       style={cellStyles}
                                       whiteSpace="nowrap"
                                       color={isDark ? '#FFF' : '#000'}
                                       minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                       {transaction.transactionAt || '-'}
                                    </Td>
                                 );
                              }

                              if (column.id === 'docno') {
                                 const docno = transaction.docno || '';
                                 const prefix = transaction.prefix || '';
                                 const postFix = transaction.postFix || transaction.suffix || '';
                                 const fullDocNo = docno ? `${prefix}${docno}${postFix}` : '-';
                                 return (
                                    <Td
                                       borderColor={borderColor}
                                       key={cellKey}
                                       p="2px"
                                       py="3px"
                                       fontSize="13px"
                                       style={cellStyles}
                                       whiteSpace="nowrap"
                                       color={isDark ? '#FFF' : '#000'}
                                       minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                       {fullDocNo}
                                    </Td>
                                 );
                              }

                              // Special handling for itemName with expandable functionality
                              if (column.id === 'itemName' && formatType === 'with_item_detail') {
                                 if (transaction.purchaseLineItems && Array.isArray(transaction.purchaseLineItems)) {
                                    if (hasMultipleItems) {
                                       return (
                                          <Td
                                             borderColor={borderColor}
                                             key={cellKey}
                                             p="2px"
                                             py="3px"
                                             fontSize="13px"
                                             whiteSpace="nowrap"
                                             textOverflow="ellipsis"
                                             color={isDark ? '#FFF' : '#000'}
                                             style={cellStyles}
                                             maxW="200px"
                                             overflow="hidden"
                                             minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                             <Text
                                                cursor="pointer"
                                                color={isDark ? '#FFF' : '#000'}
                                                onClick={(e) => {
                                                   e.stopPropagation();
                                                   toggleExpand(`items-${transaction.id}`);
                                                }}
                                                _hover={{ color: 'blue.800' }}>
                                                {transaction.purchaseLineItems[0]?.itemName || '-'}
                                             </Text>
                                          </Td>
                                       );
                                    } else {
                                       return (
                                          <Td
                                             borderColor={borderColor}
                                             key={cellKey}
                                             p="2px"
                                             py="3px"
                                             fontSize="13px"
                                             style={cellStyles}
                                             whiteSpace="nowrap"
                                             textOverflow="ellipsis"
                                             color={isDark ? '#FFF' : '#000'}
                                             maxW="200px"
                                             overflow="hidden"
                                             minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                             {transaction.purchaseLineItems[0]?.itemName || '-'}
                                          </Td>
                                       );
                                    }
                                 }
                                 return (
                                    <Td
                                       borderColor={borderColor}
                                       key={cellKey}
                                       p="2px"
                                       style={cellStyles}
                                       py="3px"
                                       fontSize="13px"
                                       color={isDark ? '#FFF' : '#000'}>
                                       -
                                    </Td>
                                 );
                              }

                              // Handle serialNo column - FIXED for both date and party report types
                              if (column.id === 'serialNo' && formatType === 'with_item_detail') {
                                 // HIDE SERIAL NUMBER FOR TEXTILE BUSINESS
                                 if (isTextile) {
                                    return (
                                       <Td
                                          borderColor={borderColor}
                                          key={cellKey}
                                          p="2px"
                                          py="3px"
                                          fontSize="13px"
                                          style={cellStyles}
                                          color={isDark ? '#FFF' : '#000'}>
                                          {/* Empty cell for TEXTILE */}
                                       </Td>
                                    );
                                 }

                                 // NON-TEXTILE: Show serial numbers normally
                                 if (transaction.purchaseLineItems && Array.isArray(transaction.purchaseLineItems)) {
                                    const item = transaction.purchaseLineItems[0];
                                    const serialNos = Array.isArray(item?.serialNo) ? item.serialNo : [];

                                    return (
                                       <Td
                                          borderColor={borderColor}
                                          key={cellKey}
                                          p="2px"
                                          py="3px"
                                          style={cellStyles}
                                          fontSize="13px"
                                          whiteSpace="nowrap"
                                          textOverflow="ellipsis"
                                          color={isDark ? '#FFF' : '#000'}
                                          maxW="200px"
                                          overflow="hidden"
                                          minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                          {serialNos.length > 0 ? (
                                             <VStack align="start" spacing={1}>
                                                {serialNos.map((serial, serialIndex) => (
                                                   <Text key={serialIndex}>{serial}</Text>
                                                ))}
                                             </VStack>
                                          ) : (
                                             'No Serial'
                                          )}
                                       </Td>
                                    );
                                 }
                                 return (
                                    <Td
                                       borderColor={borderColor}
                                       key={cellKey}
                                       p="2px"
                                       py="3px"
                                       fontSize="13px"
                                       style={cellStyles}
                                       color={isDark ? '#FFF' : '#000'}>
                                       -
                                    </Td>
                                 );
                              }

                              // Handle accountname column
                              if (column.id === 'accountname') {
                                 return (
                                    <Td
                                       borderColor={borderColor}
                                       key={cellKey}
                                       style={cellStyles}
                                       p="2px"
                                       py="3px"
                                       fontSize="13px"
                                       whiteSpace="nowrap"
                                       textOverflow="ellipsis"
                                       color={isDark ? '#FFF' : '#000'}
                                       maxW="150px"
                                       overflow="hidden"
                                       minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                       {transaction.accountname || '-'}
                                    </Td>
                                 );
                              }

                              // Handle daybookname column
                              if (column.id === 'daybookname') {
                                 return (
                                    <Td
                                       borderColor={borderColor}
                                       key={cellKey}
                                       p="2px"
                                       py="3px"
                                       fontSize="13px"
                                       px={3}
                                       whiteSpace="nowrap"
                                       style={cellStyles}
                                       textOverflow="ellipsis"
                                       color={isDark ? '#FFF' : '#000'}
                                       maxW="150px"
                                       overflow="hidden"
                                       minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                       {transaction.daybookname || '-'}
                                    </Td>
                                 );
                              }

                              // Special handling for HSN/SAC from purchaseLineItems
                              if (column.id === 'hsnSac' && formatType === 'with_item_detail') {
                                 if (transaction.purchaseLineItems && Array.isArray(transaction.purchaseLineItems)) {
                                    return (
                                       <Td
                                          borderColor={borderColor}
                                          key={cellKey}
                                          p="2px"
                                          py="3px"
                                          style={cellStyles}
                                          fontSize="13px"
                                          whiteSpace="nowrap"
                                          textOverflow="ellipsis"
                                          maxW="150px"
                                          color={isDark ? '#FFF' : '#000'}
                                          overflow="hidden"
                                          minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                          {transaction.purchaseLineItems[0]?.hsnSac || '-'}
                                       </Td>
                                    );
                                 }
                                 return (
                                    <Td
                                       borderColor={borderColor}
                                       key={cellKey}
                                       style={cellStyles}
                                       p="2px"
                                       py="3px"
                                       fontSize="13px"
                                       color={isDark ? '#FFF' : '#000'}>
                                       -
                                    </Td>
                                 );
                              }

                              // Special handling for itemRate from purchaseLineItems
                              if (column.id === 'itemRate' && formatType === 'with_item_detail') {
                                 const itemRate = transaction.purchaseLineItems?.[0]?.itemRate || 0;
                                 if (transaction.purchaseLineItems && Array.isArray(transaction.purchaseLineItems)) {
                                    return (
                                       <Td
                                          borderColor={borderColor}
                                          key={cellKey}
                                          p="2px"
                                          py="3px"
                                          style={cellStyles}
                                          fontSize="13px"
                                          whiteSpace="nowrap"
                                          textOverflow="ellipsis"
                                          color={isDark ? '#FFF' : '#000'}
                                          maxW="150px"
                                          overflow="hidden"
                                          isNumeric
                                          minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                          {formatCurrencyWithSmallDecimals(itemRate)}
                                       </Td>
                                    );
                                 }
                                 return (
                                    <Td
                                       borderColor={borderColor}
                                       key={cellKey}
                                       style={cellStyles}
                                       p="2px"
                                       py="3px"
                                       fontSize="13px"
                                       color={isDark ? '#FFF' : '#000'}
                                       isNumeric>
                                       ₹0
                                    </Td>
                                 );
                              }

                              // Handle mobile column
                              if (column.id === 'mobile') {
                                 return (
                                    <Td
                                       borderColor={borderColor}
                                       key={cellKey}
                                       style={cellStyles}
                                       p="2px"
                                       py="3px"
                                       fontSize="13px"
                                       whiteSpace="nowrap"
                                       color={isDark ? '#FFF' : '#000'}
                                       minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                       {transaction.mobile || '-'}
                                    </Td>
                                 );
                              }

                              // Handle brokername column
                              if (column.id === 'brokername') {
                                 return (
                                    <Td
                                       borderColor={borderColor}
                                       key={cellKey}
                                       style={cellStyles}
                                       p="2px"
                                       py="3px"
                                       fontSize="13px"
                                       whiteSpace="nowrap"
                                       textOverflow="ellipsis"
                                       color={isDark ? '#FFF' : '#000'}
                                       maxW="150px"
                                       overflow="hidden"
                                       minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                       {transaction.brokername || '-'}
                                    </Td>
                                 );
                              }

                              // Handle notes column
                              if (column.id === 'notes') {
                                 return (
                                    <Td
                                       borderColor={borderColor}
                                       key={cellKey}
                                       style={cellStyles}
                                       p="2px"
                                       py="3px"
                                       fontSize="13px"
                                       whiteSpace="nowrap"
                                       textOverflow="ellipsis"
                                       color={isDark ? '#FFF' : '#000'}
                                       maxW="150px"
                                       overflow="hidden"
                                       minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                       {transaction.notes || '-'}
                                    </Td>
                                 );
                              }

                              // Handle totalQty1 column - FIXED logic
                              if (column.id === 'totalQty1') {
                                 // For with_item_detail format, show ONLY the first item's quantity
                                 if (
                                    formatType === 'with_item_detail' &&
                                    transaction.purchaseLineItems &&
                                    Array.isArray(transaction.purchaseLineItems) &&
                                    transaction.purchaseLineItems.length > 0
                                 ) {
                                    return (
                                       <Td
                                          borderColor={borderColor}
                                          key={cellKey}
                                          style={cellStyles}
                                          p="2px"
                                          py="3px"
                                          fontSize="13px"
                                          whiteSpace="nowrap"
                                          color={isDark ? '#FFF' : '#000'}
                                          isNumeric
                                          minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                          {transaction.purchaseLineItems[0]?.qty1 || 0}
                                       </Td>
                                    );
                                 }
                                 // For other formats, show transaction total quantity
                                 return (
                                    <Td
                                       borderColor={borderColor}
                                       key={cellKey}
                                       style={cellStyles}
                                       p="2px"
                                       py="3px"
                                       fontSize="13px"
                                       whiteSpace="nowrap"
                                       color={isDark ? '#FFF' : '#000'}
                                       isNumeric
                                       minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                       {transaction.totalQty1 || 0}
                                    </Td>
                                 );
                              }

                              // Handle lineNetAmount column (Net Amount from line items)
                              if (column.id === 'lineNetAmount') {
                                 if (
                                    formatType === 'with_item_detail' &&
                                    transaction.purchaseLineItems &&
                                    Array.isArray(transaction.purchaseLineItems) &&
                                    transaction.purchaseLineItems.length > 0
                                 ) {
                                    return (
                                       <Td
                                          borderColor={borderColor}
                                          key={cellKey}
                                          style={cellStyles}
                                          p="2px"
                                          py="3px"
                                          fontSize="13px"
                                          whiteSpace="nowrap"
                                          color={isDark ? '#FFF' : '#000'}
                                          isNumeric
                                          minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                          {formatCurrencyWithSmallDecimals(
                                             transaction.purchaseLineItems[0]?.netAmt || 0,
                                          )}
                                       </Td>
                                    );
                                 }
                                 return (
                                    <Td
                                       borderColor={borderColor}
                                       key={cellKey}
                                       style={cellStyles}
                                       p="2px"
                                       py="3px"
                                       fontSize="13px"
                                       color={isDark ? '#FFF' : '#000'}
                                       isNumeric>
                                       ₹0
                                    </Td>
                                 );
                              }

                              // Handle billAmount column (Total Bill Amount)
                              if (column.id === 'billAmount') {
                                 return (
                                    <Td
                                       borderColor={borderColor}
                                       key={cellKey}
                                       p="2px"
                                       style={cellStyles}
                                       py="3px"
                                       fontSize="13px"
                                       whiteSpace="nowrap"
                                       color={isDark ? '#FFF' : '#000'}
                                       isNumeric
                                       minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                       {formatCurrencyWithSmallDecimals(transaction.netAmount || 0)}
                                    </Td>
                                 );
                              }
                              if (
                                 ['basicAmount', 'taxableAmount', 'gstAmount', 'netAmount'].includes(column.id) &&
                                 transaction[column.id] !== undefined
                              ) {
                                 return (
                                    <Td
                                       p="2px"
                                       py="3px"
                                       fontSize="13px"
                                       whiteSpace="nowrap"
                                       style={cellStyles}
                                       textOverflow="ellipsis"
                                       maxW="150px"
                                       overflow="hidden"
                                       color={isDark ? '#FFF' : '#000'}
                                       borderColor="gray.200"
                                       key={cellKey}
                                       minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                       isNumeric>
                                       {formatCurrencyWithSmallDecimals(transaction[column.id])}
                                    </Td>
                                 );
                              }

                              // Handle dueDays column
                              if (column.id === 'dueDays') {
                                 return (
                                    <Td
                                       borderColor={borderColor}
                                       key={cellKey}
                                       p="2px"
                                       style={cellStyles}
                                       py="3px"
                                       fontSize="13px"
                                       whiteSpace="nowrap"
                                       color={isDark ? '#FFF' : '#000'}
                                       isNumeric
                                       minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                       {transaction.dueDays || 0}
                                    </Td>
                                 );
                              }

                              // Handle boolean values
                              if (typeof transaction[column.id] === 'boolean') {
                                 return (
                                    <Td
                                       p="2px"
                                       py="3px"
                                       fontSize="13px"
                                       whiteSpace="nowrap"
                                       textOverflow="ellipsis"
                                       maxW="150px"
                                       overflow="hidden"
                                       style={cellStyles}
                                       borderColor="gray.200"
                                       key={cellKey}
                                       minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                       {transaction[column.id] ? 'Yes' : 'No'}
                                    </Td>
                                 );
                              }

                              // Default handling for all other columns
                              return (
                                 <Td
                                    p="2px"
                                    py="5px"
                                    fontSize="13px"
                                    whiteSpace="nowrap"
                                    textOverflow="ellipsis"
                                    maxW="150px"
                                    fontWeight={500}
                                    color={isDark ? '#FFF' : '#000'}
                                    overflow="hidden"
                                    borderColor="gray.200"
                                    style={cellStyles}
                                    key={cellKey}
                                    minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                    {transaction[column.id] || '-'}
                                 </Td>
                              );
                           })}
                     </Tr>

                     {/* Expanded item details rows - Multi-level item breakdown */}
                     {formatType === 'with_item_detail' &&
                        expandedItems[`items-${transaction.id}`] &&
                        transaction.purchaseLineItems &&
                        Array.isArray(transaction.purchaseLineItems) &&
                        hasMultipleItems &&
                        transaction.purchaseLineItems
                           .slice(1) // Skip the first item (0th index)
                           .map((item, itemIndex) => (
                              <Tr
                                 key={`item-${item.id || itemIndex + 1}-${transaction.id}`}
                                 bg={isDark ? 'rgba(0, 123, 255, 0.1)' : 'rgba(0, 123, 255, 0.03)'}
                                 cursor={'pointer'}
                                 onClick={() => handledata(transaction)}
                                 _dark={{ bg: 'rgba(0, 123, 255, 0.1)' }}
                                 borderLeft="3px solid"
                                 borderLeftColor="blue.200"
                                 _hover={{ bg: 'rgba(0, 123, 255, 0.06)' }}>
                                 {table
                                    .getAllColumns()
                                    .filter((column) => column.getIsVisible())
                                    .map((column) => {
                                       // Show empty cells for non-item columns except item-specific ones
                                       if (
                                          [
                                             'transactionAt',
                                             'docno',
                                             'accountname',
                                             'daybookname',
                                             'mobile',
                                             'brokername',
                                             'notes',
                                          ].includes(column.id)
                                       ) {
                                          return (
                                             <Td
                                                key={column.id}
                                                borderColor={borderColor}
                                                p="2px"
                                                py="3px"
                                                fontSize="12px"
                                                color="gray.400"
                                                pl={8}
                                                alignContent="start">
                                                {/* Empty cell for transaction-level data */}
                                             </Td>
                                          );
                                       }

                                       // Show item name
                                       if (column.id === 'itemName') {
                                          return (
                                             <Td
                                                key={column.id}
                                                borderColor={borderColor}
                                                p="2px"
                                                py="3px"
                                                fontSize="12px"
                                                whiteSpace="nowrap"
                                                textOverflow="ellipsis"
                                                color="blue.700"
                                                maxW="200px"
                                                overflow="hidden"
                                                minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                                alignContent="start">
                                                {item.itemName}
                                             </Td>
                                          );
                                       }

                                       // Show serial numbers for each item
                                       if (column.id === 'serialNo') {
                                          // HIDE SERIAL NUMBER FOR TEXTILE BUSINESS
                                          if (isTextile) {
                                             return (
                                                <Td
                                                   key={column.id}
                                                   borderColor={borderColor}
                                                   p="2px"
                                                   py="3px"
                                                   fontSize="12px"
                                                   color={isDark ? '#FFF' : '#000'}>
                                                   {/* Empty cell for TEXTILE */}
                                                </Td>
                                             );
                                          }
                                          const serialNos = Array.isArray(item.serialNo) ? item.serialNo : [];

                                          return (
                                             <Td
                                                key={column.id}
                                                borderColor={borderColor}
                                                p="2px"
                                                py="3px"
                                                fontSize="12px"
                                                whiteSpace="nowrap"
                                                textOverflow="ellipsis"
                                                color={isDark ? '#FFF' : '#000'}
                                                maxW="200px"
                                                overflow="hidden"
                                                minW={{ sm: '150px', md: '200px', lg: 'auto' }}>
                                                {serialNos.length > 0 ? (
                                                   <VStack align="start" spacing={1}>
                                                      {serialNos.map((serial, serialIndex) => (
                                                         <Text key={serialIndex}>{serial}</Text>
                                                      ))}
                                                   </VStack>
                                                ) : (
                                                   <Text color={isDark ? '#FFF' : '#000'} fontStyle="italic" fontSize="11px">
                                                      No Serial
                                                   </Text>
                                                )}
                                             </Td>
                                          );
                                       }

                                       // Show HSN/SAC for each item
                                       if (column.id === 'hsnSac') {
                                          return (
                                             <Td
                                                key={column.id}
                                                borderColor={borderColor}
                                                p="2px"
                                                py="3px"
                                                fontSize="12px"
                                                whiteSpace="nowrap"
                                                color={isDark ? '#FFF' : '#000'}
                                                minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                                alignContent="start">
                                                {item.hsnSac || '-'}
                                             </Td>
                                          );
                                       }

                                       // Show item rate - CORRECTED to use the current item's rate
                                       if (column.id === 'itemRate') {
                                          return (
                                             <Td
                                                key={column.id}
                                                borderColor={borderColor}
                                                p="2px"
                                                py="3px"
                                                fontSize="12px"
                                                whiteSpace="nowrap"
                                                color={isDark ? '#FFF' : '#000'}
                                                isNumeric
                                                minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                                alignContent="start">
                                                ₹{Number(item.itemRate || 0).toLocaleString()}
                                             </Td>
                                          );
                                       }

                                       // Show item basic amount
                                       if (column.id === 'basicAmount') {
                                          return (
                                             <Td
                                                key={column.id}
                                                borderColor={borderColor}
                                                p="2px"
                                                py="3px"
                                                fontSize="12px"
                                                whiteSpace="nowrap"
                                                color={isDark ? '#FFF' : '#000'}
                                                isNumeric
                                                minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                                alignContent="start">
                                                ₹{Number(item.basicAmount || item.netAmt || 0).toLocaleString()}
                                             </Td>
                                          );
                                       }

                                       // Show taxable amount
                                       if (column.id === 'taxableAmount') {
                                          return (
                                             <Td
                                                key={column.id}
                                                borderColor={borderColor}
                                                p="2px"
                                                py="3px"
                                                fontSize="12px"
                                                whiteSpace="nowrap"
                                                color={isDark ? '#FFF' : '#000'}
                                                isNumeric
                                                minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                                alignContent="start">
                                                ₹{Number(item.taxableAmount || item.netAmt || 0).toLocaleString()}
                                             </Td>
                                          );
                                       }

                                       // Show GST amount
                                       if (column.id === 'gstAmount') {
                                          const gstAmount =
                                             (item.cgst || 0) + (item.sgst || 0) + (item.igst || 0) + (item.cess || 0);
                                          return (
                                             <Td
                                                key={column.id}
                                                borderColor={borderColor}
                                                p="2px"
                                                py="3px"
                                                fontSize="12px"
                                                whiteSpace="nowrap"
                                                color={isDark ? '#FFF' : '#000'}
                                                isNumeric
                                                minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                                alignContent="start">
                                                ₹{Number(gstAmount).toLocaleString()}
                                             </Td>
                                          );
                                       }

                                       // Show individual item quantity for each expanded item
                                       if (column.id === 'totalQty1') {
                                          return (
                                             <Td
                                                key={column.id}
                                                borderColor={borderColor}
                                                p="2px"
                                                py="3px"
                                                fontSize="12px"
                                                whiteSpace="nowrap"
                                                color={isDark ? '#FFF' : '#000'}
                                                isNumeric
                                                minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                                alignContent="start">
                                                {item.qty1 || 0}
                                             </Td>
                                          );
                                       }

                                       if (column.id === 'lineNetAmount') {
                                          return (
                                             <Td
                                                borderColor={borderColor}
                                                key={column.id}
                                                p="2px"
                                                py="3px"
                                                fontSize="13px"
                                                whiteSpace="nowrap"
                                                color={isDark ? '#FFF' : '#000'}
                                                isNumeric
                                                minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                                alignContent="start">
                                                ₹{Number(item.netAmt || 0).toLocaleString()}
                                             </Td>
                                          );
                                       }

                                       // Show due days if applicable
                                       if (column.id === 'dueDays') {
                                          return (
                                             <Td
                                                key={column.id}
                                                borderColor={borderColor}
                                                p="2px"
                                                py="3px"
                                                fontSize="12px"
                                                whiteSpace="nowrap"
                                                color={isDark ? '#FFF' : '#000'}
                                                isNumeric
                                                minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                                alignContent="start">
                                                {transaction.dueDays || 0}
                                             </Td>
                                          );
                                       }

                                       // Default empty cell for other columns
                                       return (
                                          <Td
                                             key={column.id}
                                             borderColor={borderColor}
                                             p="2px"
                                             py="3px"
                                             fontSize="12px"
                                             color="gray.400"
                                             minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                             alignContent="start">
                                             {/* Empty cell */}
                                          </Td>
                                       );
                                    })}
                              </Tr>
                           ))}
                  </React.Fragment>
               );
            })}
         </>
      );
   };

   const memoizedReportContent = useMemo(
      () => renderReportContent(),
      [isLoading, salesReport, reportType, expandedItems, formatType, textColor, borderColor, colorMode],
   );

   const handleShowHideFormOpen = async () => {
      setIsShowHideColumn(true);
      const formatData = reportformat.find((f) => f.title === reportType);
      if (formatData) {
         setIsEditShowHide(true);
         setEditData(formatData);
      } else {
         setIsEditShowHide(false);
         setEditData({});
      }
   };

   return (
      <>
         {/* Title Outside Card */}
         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()} // Navigate to the previous page
                  style={{ cursor: 'pointer' }} // Ensure it's clickable
               ></img>
               <Text color={isDark ? '#FFF' : '#000'} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Purchase Return Detail
               </Text>
            </Flex>
            <Flex>
               <Box cursor={'pointer'} onClick={() => handleShowHideFormOpen()} mr={2}>
                  {isStaticReportType ? <FiPlusCircle size={22} /> : <LucideEdit size={22} />}
               </Box>
            </Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex alignItems="center" gap={3} justifyContent={'end'}>
               <div flex="1" mr={''} justifyContent="center">
                  <Box my={2} width="300px" fontSize={'13px'} fontWeight={500} display={{ base: 'none', xl: 'block' }}>
                     <GridItem className="seperator-width" mt={5}>
                        {renderDynamicDropdown(
                           'company',
                           'Company',
                           lastcompanyOptions,
                           {
                              value: companyFilter,
                              onChange: handleCompanyChange,
                           },
                           {},
                           textColor,
                           false,
                           'Select company',
                           true,
                           undefined,
                           true,
                        )}
                     </GridItem>
                  </Box>
               </div>
               <Box flex="1" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last7Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
                  <Box my={2} zIndex={3} width={'150px'} fontSize={'13px'} fontWeight={500} mr={2}>
                     <label>Report Type</label>
                     <Select
                        options={reportTypeOptions}
                        formatOptionLabel={formatOptionLabel}
                        value={reportTypeOptions.find((option) => option.value === reportType)}
                        onChange={handleReportTypeChange}
                        placeholder="Select Report Type"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              fontWeight: state.data?.isDynamic ? 'bold' : 'normal', // Style dynamic options differently
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           groupHeading: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
                  <Box my={2} zIndex={3} fontSize={'13px'} fontWeight={500}>
                     <label>Format</label>
                     <Select
                        options={formatTypeOptions}
                        value={reportTypeOptions.find((option) => option.value === formatType)}
                        onChange={(selectedOption) => {
                           setFormatType(selectedOption.value);
                           setExpandedItems({}); // Reset expanded items when changing report type
                        }}
                        defaultValue={formatType}
                        placeholder="Select Format Type"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           menu: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
               </Box>
               <Flex>
                  <Flex alignItems="center">
                     <Flex mr={2}>
                        <Box flex="1" mr={3}>
                           <MotionFlex
                              ref={wrapperRef}
                              align="center"
                              bg={bg}
                              borderRadius="full"
                              cursor="pointer"
                              px={expanded ? 3 : 0}
                              w={expanded ? '250px' : '40px'} // Wider for full input
                              h="40px"
                              transition="all 0.3s ease"
                              onClick={() => setExpanded(true)}>
                              <MotionSearchIcon
                                 color={icon}
                                 animate={{ rotate: expanded ? 0 : 90 }}
                                 transition={{ duration: 0.3 }}
                                 style={{
                                    marginRight: expanded ? '8px' : '10px',
                                    marginLeft: expanded ? '0' : '10px',
                                 }}
                              />
                              {expanded && (
                                 <Input
                                    variant="unstyled"
                                    placeholder="Search ..."
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                    autoFocus
                                    color={icon}
                                    flex="1"
                                 />
                              )}
                           </MotionFlex>
                        </Box>
                        <Button onClick={handleRefresh} _hover={{ bg: 'blue.50' }} mr={2}>
                           <MdOutlineRefresh size={20} mr={2} />
                        </Button>

                        <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                           <IoFilterOutline size={22} />
                        </Button>
                     </Flex>
                     <Flex mr={2}>
                        <Popover>
                           <PopoverTrigger>
                              <IconButton
                                 icon={<Image src={Download} boxSize="24px" />}
                                 aria-label="Download Options"
                              // variant="outline"
                              />
                           </PopoverTrigger>

                           <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                              <PopoverBody p="3">
                                 <Button
                                    width="100%"
                                    variant="ghost"
                                    _hover={{ bg: 'blue.100' }}
                                    onClick={downloadExcel}
                                    justifyContent="space-between"
                                    mb={3}>
                                    <img src={xls} alt="Download XLS" width="30px"></img>
                                    Download Excel
                                 </Button>
                                 <Button
                                    width="100%"
                                    variant="ghost"
                                    _hover={{ bg: 'blue.100' }}
                                    onClick={downloadPDF}
                                    justifyContent="space-between">
                                    <img src={xls} alt="Download PDF" width="30px"></img>
                                    Download PDF
                                 </Button>
                              </PopoverBody>
                           </PopoverContent>
                        </Popover>
                     </Flex>
                  </Flex>
               </Flex>
               <Box ml={1}>
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={fromDateInputRef}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter, // Filter based on companyFilter values
                                 onChange: handleCompanyChange, // Handle change
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true, // isSearchable
                              undefined, // filteredOptions (optional, can be null or undefined)
                              true, // isMulti
                           )}
                        </GridItem>
                        <Box my={2} fontSize={'13px'} fontWeight={500}>
                           <label>Report Type</label>
                           <Select
                              options={reportTypeOptions}
                              value={reportTypeOptions.find((option) => option.value === reportType)}
                              onChange={(selectedOption) => {
                                 setReportType(selectedOption.value);
                                 setExpandedItems({}); // Reset expanded items when changing report type
                              }}
                              placeholder="Select Report Type"
                           />
                        </Box>
                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker
                              value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                              onChange={handleDateRangeChange}
                              defaultPeriod="last7Days"
                              style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>

                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '60vh', md: '65vh', xl: '70vh' }}
                  maxH={{ base: '60vh', md: '65vh', xl: '70vh' }}>
                  {isFilterLoading && (
                     <Box
                        position="fixed"
                        top={0} left={0} right={0} bottom={0}
                        zIndex={9999}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bg={isDark ? 'rgba(10,20,50,0.60)' : 'rgba(255,255,255,0.60)'}
                        backdropFilter="blur(3px)"
                     >
                        <Flex direction="column" align="center" gap={3}>
                           <Loader />
                        </Flex>
                     </Box>
                  )}
                  <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                     <Thead></Thead>
                     <Tbody>{memoizedReportContent}</Tbody>
                  </Table>
               </Box>
            </Card>
         </Grid>

         <SalesPurchaseFilter
            type={reportType}
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyIds}
            fromDate={dateRange.fromDate}
            toDate={dateRange.toDate}
            entityType="PurchaseReturnDetail"
            onApply={() => setIsFilterLoading(true)}
         />

         <ColumnShowHide
            isOpen={isShowHideColumn}
            onClose={() => setIsShowHideColumn(false)}
            data={columnsData}
            setShowHideData={setShowHideData}
            isedit={isEditShowHide}
            editData={editData}
            selectedFormat={reportTypeOptions.dynamicOptions}
            FixdefName1={'PurchaseReturnDetailDate'}
            FixdefName2={'PurchaseReturnDetailParty'}
            FixdefName3={'PurchaseReturnDetailBroker'}
            staticOption={staticOption}
            dynamicEditOption={dynamicEditOption}
         />

         {/* Column Visibility Modal */}
         <SalesDetails
            isOpen={isOpenPurchaseReturnSingleView}
            onClose={handleSalesDetailsClose}
            singleEntityRights={purchaseInvoiceRight || purchaseReturnRight}
            title={'Purchase Return'}
            entityType={'purchasereturn'}
            singleEntity={viewDetail}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            setIsEditFormOpen={setIsEditFormOpen}
            setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
            isEditFormOpen={isEditFormOpen}
            // paginate={paginateData}
            viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems}
            billTerms={viewDetail?.purchasereturnbillteams}
            onDelete={deletePurchaseReturn}
            handleSerchClose={() => console.log('')}
         />

         <DeletePasswordModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onConfirm={deletePurchaseReturn}
            id={dataId}
            deleteApi={deletePurchaseReturnInvoice}
            dispatch={dispatch}
            type={'receive'}
            userGlobalSettingsData={userGlobalSettingsData}
         />
      </>
   );
};

export default PurchaseReturnDetail;
